export const navbar = {
  en: {
    title: "ShipVista",
    getQuote: "Get Instant Quotes",
    pricing: "Pricing",
    partners: "Partners",
    airmiles: "Airmiles®",
    UPSCapital: "UPS Capital",
    technologyPartners: "Technology Partners",
    fulfillmentPartners: "Fulfillment Partners",
    otherCarriers: "Other Carriers",
    developers: "Developers",
    signUp: "Sign Up For Free",
    signUpShort: "Sign Up",
    login: "Log In",
    contactNumber: " (855) 434-3477 ",
    contactMail: " customercare@shipvista.com ",
    trackMyShipment: "Track My Shipment",
    blog: "Blog",
    support: "Support",
    company: "Company",
    logoAlt: "Shipvista Brand",
  },
};

export const helpArticle = {
  en: {
    inputPlaceholder: "Search for article...",
  },
};

export const hero = {
  en: {
    heading: `<h1>Enter for a chance to win <br> AIR MILES<sup>®</sup> Reward Miles<sup>TM</sup> at ShipVista</h1>`,
    buttonText: "SEE MORE DETAILS",
  },
};

export const about = {
  en: {
    heading:
      "Leveraging The Same Inventory And Order Fulfillment Technology Used By ECommerce Leaders.",
    para1:
      '<p class="fs-6">Picking the right 3PL partner will save you future headaches, Expand your reach, increase profitability, and deliver an exceptional customer experience all in one platform.</p>',
    para2:
      '<p class="fw-normal mb-0">ShipVista.com is an <b class="text-decoration-underline">all-in-one</b> multichannel shipping platform that offers <b class="text-decoration-underline">real-time carrier rates</b>, <b class="text-decoration-underline">automated print shipping labels</b>, and <b class="text-decoration-underline">powerful tools</b> that allow e-commerce businesses, platforms, online marketplaces, and sellers to integrate shipping with <b class="text-decoration-underline">multiple carriers</b> through our API and web application to manage their operations more efficiently.</p>',
    ctaText: "Try Shipvista Now For Free",
    sec2Title: "WELCOME CUSTOMER OFFER",
    sec2Heading: "Get Your First Deposit Matched Up To $1000.",
    sec2Link: "T&Cs, time limits and exclusions apply",
  },
};

export const help = {
  en: {
    title: "HOW CAN WE HELP YOU?",
    inputPlaceholder: "Search Our Features",
    card1Text: "SHIPVISTA HELP",
    card2Text: "INTEGRATIONS",
    card3Text: "WORKFLOWS",
    card4Text: "GUIDE & FAQS",
  },
};

export const howItWorks = {
  en: {
    //
    title: "WHAT YOU CAN DO WITH SHIPVISTA",
    card1Heading: "CONNECT YOUR STORE",
    card1Para:
      "Sync all of your sales channels to easily manage orders in one place.",
    card2Heading: "PRINT DISCOUNTED SHIPPING LABELS",
    card2Para:
      "Get the lowest-possible rates from Canada Post, UPS, Canpar, and more.",
    card3Heading: "TRACK SHIPMENTS AND NOTIFY CUSTOMERS",
    card3Para:
      "Tracking and notifications to keep you and your customers up-to-date.",
    card4Heading: "STREAMLINE RETURNS",
    card4Para: "Generate return labels automatically, for free.",
    learnMore: "Learn More",
    //
    title2: "MUCH MORE ON WHY SHIPVISTA.COM",
    card2Heading1: "Save hours every week",
    card2Para1:
      "No more manual label creation. Use automation and print labels in seconds, with 1 click.",
    card2Heading2: "Ship with multiple carriers",
    card2Para2:
      "Ship with our default carriers or find the best option for your needs, at home and abroad.",
    card2Heading3: "Lower your shipping costs",
    card2Para3:
      "Use our pre-negotiated prices to save money by creating discounted shipping labels.",
    card2Heading4: "Work in a clear, easy to use platform",
    card2Para4:
      "Avoid wasting time on hard to grasp shipping tools. Use only one instead, for all your shipping needs.",
    //list
    l1: "Connect your sales channels to easily Sync and manage all orders in one place. (Shopify, eBay, WooCommerce, Walmart Canada, Etsy, and More).",
    l2: "Get Pre-negotiated shipping rates from Canada Post, UPS, and more. We negotiated the best rates for you – up to 76% off.",
    l3: "Eliminate Post Office trips and Get postage discounts you can’t get at the Post Office.",
    l4: "Calculate and Compare rates from all carriers on a single screen with Rate Advisor - never overpay again.",
    l5: "Print discounted shipping labels directly from your desk or mobile.",
    l6: "Manage all your carriers from one account, Connect your own Canada Post, UPS carriers account for shipping.",
    l7: "Notify your customers with up-to-date Tracking status.",
    l8: "Hassle-free international shipping options.",
    //
    title3: "The best carriers. The best rates. All in one place.",
  },
};

export const forPlatforms = {
  en: {
    title: "SHIPVISTA FOR PLATFORMS",
    liveRates: "Live Rates Directly for:",
    shopify: "Shopify",
    magento: "Magento",
    woocommerce: "Woocommerce",
  },
};

export const technologyPartners = {
  en: {
    title: "TECHNOLOGY PARTNERS",
    subHeading:
      "Partnered with several technologies to enhance your experience",
    para: "We have partnered with several known technological marketplace/e-commerce platforms such as Walmart Canada, Shopify, E-bay, Etsy, and WooCommerce to help you get the best experience.",
    ctaText: "See our Technology Partners",
  },
};

export const fulfillmentPartners = {
  en: {
    title: "FULFILLMENT PARTNERS",
    subTitle: "Partnered with several carriers to get you the best rates",
    para: "We are continuing to grow our fulfillment partnerships so you can grow your business to new regions with greater convenience for you and your customers.",
    ctaText: "See our Fulfillment Partners",
  },
};

export const referralProgram = {
  en: {
    title: "REFERRAL PROGRAM",
    subTitle: "How does our program work?",
    card1Heading: "1. Register as an affiliate",
    card1Para:
      "Earn revenue for referring new ShipVista users. It’s free to join - no fees and no minimum sales.",
    card2Heading: "2. Promote ShipVista",
    card2Para:
      "Help grow ShipVista’s global user base. When your visitors, or clients, click your link and sign up for ShipVista, you make money starting from their first shipment.",
    card3Heading: "3. Start earning",
    card3Para:
      "Refer visitors to ShipVista and earn for every paid subscriber. Join today to grow your revenue!",
    ctaText: "Get Started Now",
  },
};

export const footer = {
  en: {
    resources: "Resources",
    openAccountOffer: "Open Account Offer",
    howItWorks: "How It Works",
    shipvistaForPlatforms: "ShipVista For Platforms",
    documentToolkit: "Document Toolkit",
    quickVideos: "Quick Videos",
    features: "Features",
    developers: "Developers",
    overview: "Overview",
    apiStatus: "API Status",
    partners: "Partners",
    technologyPartners: "Technology Partners",
    fulfillmentPartners: "Fulfillment Partners",
    otherCarriers: "Other Carriers",
    becomeAPartner: "Become A Partner",
    becomeAnAffiliate: "Become An Affiliate",
    company: "Company",
    aboutUs: "About Us",
    careers: "Careers",
    newsroom: "Newsroom",
    termsOfUse: "Terms Of Use",
    privacyPolicy: "Privacy Policy",
    contact: "Contact",
    helpCenter: "Help Center",
    contactUs: "contactUs",
    creditCardConsentAgreement: "Credit Card Consent Agreement",
    commissionProgramAgreement: "Commission Program Agreement",
    usdotno: "USDOT Number: 3852466",
    usditlink:
      "https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=USDOT&original_query_param=NAME&query_string=3852466&original_query_string=SHIPVISTA%20CORPORATION",
    copyright: "© " + new Date().getFullYear() + " ShipVista.com",
    sitemap: "Sitemap",
    doNotSellMyPersonalInfo: "Do Not Sell My Personal Information",
    poweredBy: "Powered By:",
    shipvistacom: "ShipVista.com",
    twitterLink: "https://twitter.com/shipvista",
    facebookLink: "https://facebook.com/Shipvista",
    instagramLink: "https://instagram.com/shipvista",
    linkedinLink: "https://ca.linkedin.com/company/shipvista",
    youtubeLink: "https://www.youtube.com/channel/UCDufq0fTJVUih9GGj7O9qyg",
  },
};

export const technology = {
  en: {
    title: "Technology Partners",
    subTitle:
      "E-commerce and Marketplace technologies that we've partnered with to provide our services to retailers",
    searchInputPlaceholder: "Search",
    filterBy: "Filter by",
    countries: "Countries",
    featured: "Featured",
    marketplace: "Marketplace",
    ecommerce: "E-commerce",
    other: "Other",
    footer1:
      "Don't see the solution you are looking for? Send your feedback to",
    footerEmail: " customercare@shipvista.com",
    footer2: "Interested in becoming a partner? Start your journey",
    footerLink: "https://shipvista.com/become-a-partner",
    here: "here",
  },
};

export const fulfillment = {
  en: {
    title: "Fulfillment Partners",
    subTitle: "Choose from a variety of partners to ship with using ShipVista",
    searchInputPlaceholder: "Search",
    filterBy: "Filter by",
    countries: "Countries",
    featured: "Featured",
    comingsoon: "Coming Soon",
    other: "Other",
    footer1: "Don't see your fulfillment partner listed?",
    footerEmail: " customercare@shipvista.com",
    footer2: "Interested in becoming a partner? Start your journey",
    footerLink: "https://shipvista.com/become-a-partner",
    here: "here",
  },
};

export const partner = {
  en: {
    about: "About",
    integrate: "Integrate",
    accountToShipvista: "Account on ShipVista",
    requirement: "Requirement",
    connect: "Connect",
    availableFeatures: "Available Features",
    additionalDetails: "Additional Details",
    troubleshooting: "Troubleshooting",
    followSteps: "Follow the steps below to connect you",
    toShipVista: "to ShipVista.",
    integrationRequirements: "Integration Requirements:",
    shipvistaIntegration: "ShipVista's integration with",
    supports: "supports the following standard features:",
    commonIntegrationFeatures: "Common Integration Features",
    feature: "Feature",
    status: "Status",
    support: "Supported?",
    shipvistaUpdate: "Sent with Shipment Update",
    shipvista: "ShipVista",
    field: "Field",
    shipVistaPartnerTitle: (p: string) =>
      `ShipVista is a certified ${p} partner. Activate your account and start saving on shipments today.`,
    card1Title: "Save on Fuel Surcharges",
    card2Title: "Worldwide UPS tracking",
    card3Title: "Domestic and international delivery services",
    card4Title: "No minimum shipping",
    faq: "Frequently Asked Questions",
    faqPara: (p: string) =>
      `More on shipping with ${p} - Common questions about ${p}.`,
    integrationTitle: (p: string) => `Integrate ${p} Account on ShipVista`,
  },
};

export const ups = {
  en: {
    title: "Discounted UPS® Shipping Rates on ShipVista",
    title2:
      "ShipVista is a certified UPS® vendor partner. Activate your account and start saving on shipments today.",
    aboutUPS: "About UPS",
    about:
      "United Parcel Service (UPS) is a global package delivery company that offers a wide range of shipping services for businesses and individuals. ShipVista is a certified UPS Ready® application that allows you to get rates and create domestic and international shipping labels via your negotiated UPS shipping rates. UPS helps both large and small businesses with their logistical needs. UPS offers sustainability options like paperless invoices and their Carbon Neutral program.",
    title3: "Enjoy Shipping with UPS Discounted Rates on ShipVista",
    para3:
      "When you ship UPS on ShipVista, merchants can instantly access discounted UPS shipping rates, which means that your business could save up to 76% off for Canada origin shipments and save up to 82% off for US origin shipments.  Start utilizing combined power of UPS with ShipVista capabilities to automate shipping, compare rates, process batch labels, integrate with marketplaces and streamline logistics.",
    btn1: "UPS Ready Program",
    card1Title: "No additional surcharges",
    card2Title: "Worldwide UPS tracking",
    card3Title: "Domestic and international delivery services",
    card4Title: "No minimum shipping",
    title4: "The ShipVista and UPS Advantage",
    para4:
      "ShipVista is a certified UPS Ready® application and ShipVista users will enjoy seamless connectivity to UPS® shipping services with competitive discounts and more benefits:",
    disclaimer:
      "*Disclaimer: Discounts off UPS daily rates. Rates are limited to shipping from the U.S. only. Rates and any applicable discounts are subject to change at any time without notice.",
    disclaimer2:
      "*Discounts off UPS daily rates. Rates are limited to shipping from Canada only. Rates and any applicable discounts are subject to change at any time without notice.",
    disclaimer3:
      "*Inclusive of applicable fuel and residential surcharge. Not including other additional applicable charges and taxes.",
    list4: [
      "Discounts are pre-loaded regardless of how much or often you ship",
      "15 Delivery options to choose from (domestic and international)",
      "Global reach of 220+ countries and territories",
      "Increased weight and size flexibility",
      "Streamlined customs clearance to facilitate imports and exports",
      "Let customers choose the service that best fits their needs,whether it's overnight, Saturday delivery, or international shipping.",
    ],
    bigCard1Title: "What are the discounts?",
    bigCard1Para:
      "When you open a UPS account on ShipVista, you instantly get access to the following discounts on both domestic and international shipping for popular UPS services:",
    bigCard1List: [
      "Up to 78% off UPS® Ground shipments",
      "Up to 73% off on daily rates for UPS 2nd Day Air® service and UPS Next Day Air service",
      "Up to 82% off on international service*",
    ],
    bigCard2Para2:
      "*Discounts off UPS daily rates. Rates are limited to shipping from the U.S. only. Rates and any applicable discounts are subject to change at any time without notice.",
    title5: "UPS® Service Levels",
    para5:
      "UPS offers multiple service options to fit your needs. The variety of UPS services allows you to balance shipping costs, time in transit, and customer experience. UPS requires for single packages:",
    list5: [
      "Packages can be up to 150 lbs",
      "Packages can be up to 165 inches in length and girth combined",
      "Packages can be up to 108 inches in length",
      "Packages with a large size-to-weight ratio require special pricing and dimensional weight calculations",
    ],
    cardTableHeading: "Export and Import",
    canadaToCanada: "CANADA TO CANADA",
    canadaToUs: "CANADA TO U.S.",
    canadaToWorldWide: "CANADA WORLDWIDE",
    early: "UPS Express® Early",
    express: "UPS Express®",
    expressSaver: "UPS Express Saver®",
    select: "UPS 3 Day Select®",
    expedited: "UPS Expedited®",
    standard: "UPS® Standard",
    earlycc: "Guaranteed delivery the next business day by 9:00 a.m.",
    earlycus: "Guaranteed delivery the next business day as early as 8:00 a.m.",
    earlyww: "Guaranteed delivery in 2+ business days by 9 a.m.",
    expresscc: "Guaranteed next business day delivery by 10:30 a.m. or noon",
    expressus: "Guaranteed next business day delivery by 10:30 a.m. or noon",
    expressww:
      "Guaranteed delivery in 2+ business days by 10:30 a.m., noon or 2:00 p.m.",
    expressSavercc: "Guaranteed next business day delivery by 3:00 p.m.",
    expressSaverus: "Guaranteed next business day delivery",
    expressSaverww: "Guaranteed delivery in 2+ business days",
    expeditedcc: "Guaranteed delivery by the second business day",
    expedatedus: "Guaranteed delivery by the second business day",
    expedatedww: "Guaranteed delivery in 3+ business days.",
    standardcc: "Guaranteed day definite service for less urgent shipments",
    standardus: "Guaranteed day definite service for less urgent shipments",
    selectUs: "Guaranteed delivery by the third business day",
    title6: "How to Ship Internationally with UPS®",
    para6:
      "There are numerous opportunities available for your business. As the most experienced and well-equipped carrier, UPS delivers items to more locations than any other company.To ship internationally using UPS®, you can follow these steps:",
    list6: [
      "Firstly You need to gather the necessary paperwork and documents for international shipping, such as a commercial invoice, bill of lading, or shipper's export declaration. These will vary depending on the country you are shipping to and the contents of the package.",
      "Pack your item securely and clearly label it with the recipient's name and address.",
      "Go to the ShipVista Platform and create a shipment with UPS® by entering the necessary information such as the recipient's address, package weight, and dimensions.",
      "If you scheduled a pickup, place the package outside on the scheduled date and time.",
      "Choose the shipping service that best meets your needs and budget. UPS® offers several international shipping options, including UPS® Worldwide Express, UPS® Worldwide Expedited, and UPS® Standard.",
      "Print out the shipping label and affix it to the package.",
      "Take the package to a UPS® location or schedule a pickup for the package.",
      "Track the package to ensure it has been received and processed by the recipient.",
    ],
    para6note:
      "Disclaimer : International shipping requires additional requirements and regulations, and please make sure to check with UPS® and the destination country's regulations before shipping.",
    title7: "UPS ACCESS POINT®  LOCATIONS",
    para7:
      "UPS provides a market-leading global network of more than 78,000 UPS Access Point® sites, including more than 1,500 in Canada, for package pickup or delivery.",
    list7: [
      "Drop Off: Bring your pre-labeled parcels to any UPS Access Point® facility in the area to drop them off.",
      "Pickup: Give your customers reliable delivery solutions.When customers can't be home to accept a delivery or if they are worried about leaving parcels unattended, they can use UPS Access Point® sites as an alternative delivery location. Members of UPS My Choice® have the option to reroute any or all of their packages to a preferred UPS Access Point ® location at any time by logging into their accounts.",
    ],
    bigCard2Col1title: "UPS® Tracking",
    bigCard2Col1Para1:
      "To track a package, simply enter the tracking number for your shipment. The tracking number can be found on your UPS® shipping label, in your shipping confirmation email, or in your UPS® account if you have one.Once you enter the tracking number, you will be taken to a page that displays the current location and status of your delivery, as well as any recent updates or events that have taken place.",
    bigCard2Col1Para2:
      "UPS® tracking allows you to plan ahead and know exactly when to expect your package, which is especially helpful if you need to be home to receive it. It also helps you stay informed in case of any unexpected delays or changes to your delivery.",
    bigCard2Col2title: "How to track a UPS® Shipment?",
    bigCard2Col2Para1:
      "When you're running a business, time is a precious commodity. Let ShipVista give you an edge by putting your order details, customer information, label printing, and shipment tracking all in one place.",
    trackingNumber: "Tracking Number",
    search: "Search",
    searchBtn: "TRACK SHIPMENT",
    title8: "How to Return a UPS package",
    para8: "To return a package using UPS, you can follow these steps:",
    list8: [
      "Obtain a return shipping label from the retailer or company to which you are returning the package to.",
      "Affix the label to the package, making sure to cover any old labels or barcodes.",
      "Take the package to a UPS location or schedule a pickup for the package. Be sure to bring your identification if you take the package to UPS.",
      "If you scheduled a pickup, place the package outside on the scheduled date and time.",
      "Track the package to ensure it has been received and processed by the retailer.",
    ],
    para8Note:
      "Disclaimer: If you don't have a return label, you can create a return label, then print it and follow steps 2-5.",
    voidShipment: {
      title: "How To Void a UPS Shipment",
      linkText: "(Learn More)",
      cols: [
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/ups-cancel-2.png",
          title: "Navigate to Shipment History page",
          para: "If you wish to cancel or void a shipment that has recently been created, first navigate to the Shipment History page by using the top navigation bar. Click the 'Shipments' tab at the top navigation and then 'Shipment History' on the side panel.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/ups-cancel-3.png",
          title: "Look for the shipment on the Shipments History page",
          para: "On the Shipment History page, you will see a table displaying all your recent shipments that were created. Look for the shipment that you want to cancel by looking for the id or tracking number listed under the 'Marketplace #' and 'Tracking #' columns.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/ups-cancel-4.png",
          title: "Click the Action button",
          para: "Once you have found the shipment, click the 'Action' button to the right side of the entry in the table for that shipment.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/ups-cancel-5.png",
          title: "Click the Cancel button",
          para: "After clicking the 'Action' button, a popover will appear giving you a list of actions that could be performed for the shipment. Click the 'Cancel' button in the list of actions.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/ups-cancel-6.png",
          title: "Confirm Cancel",
          para: "A dialog will appear after you click cancel, prompting you to confirm your choice to cancel the shipment. Click the 'Cancel Shipment' button withing the dialog to confirm.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/ups-cancel-7.png",
          title: "Shipment Canceled",
          para: "After confirming your choice, the shipment will be canceled. A strikethrough will be displayed over the shipment that was canceled on the Shipment History table.",
        },
      ],
    },
    title9: "How To Void a UPS Shipment",
    para9:
      "Regardless of which UPS shipping system you use, voiding an unshipped package is easy. To Void a package using UPS, you can follow these steps:",
    list9: [
      "Login to view your shipping history",
      "To access the Actions menu, click the vertical ellipsis icon.",
      'Choose "Void."',
      "A red dot will show up next to the package in the Voided column once you have successfully voided it.",
    ],
    para9Note:
      "Note: If your label was made more than 90 days ago, you must get in touch with UPS and ask for a void. After 180 days, a void will not be processed.",
    faq: "Frequently Asked Questions",
    faqPara1: "More on shipping with UPS.",
    faqPara2:
      "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
    faqList: [
      {
        title: "Can I integrate my UPS® account to ShipVista?",
        desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
      },
      {
        title: "How can I contact UPS®?",
        desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
      },
      {
        title: "Does UPS require a signature on delivery?",
        desc: "You can find tracking number for the UPS® shipment provided in shipment History the ShipVista website.",
      },
      {
        title: "Does UPS require a signature on delivery?",
        desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of label creation whether or not a signature on delivery will be necessary for release.",
      },
    ],
    integration: "Integrating UPS Account on ShipVista",
  },
};

export const blogSearch = {
  en: {
    title: "ShipVista Blog - Latest articles about everything shipping related",
    inputPlaceholder: "Search articles",
  },
};

export const blogArticle = {
  en: {
    title: "Blog",
    notFound: "Could not find that article",
  },
};

export const blogArticleContent = {
  en: {
    writtenBy: "Written By",
    link1: " Click here to watch video on WooCommerce",
    title1: "Screenshots",
    title2: "Know more about ShipVista by watching quick setup videos below",
    share: "Share On",
  },
};

export const otherBlogs = {
  en: {
    title: "Other Articles",
    noArticles: "Sorry. There are no articles that match that search term",
    mostRecentTitle: "Featured Most Recent Articles",
    viewMore: "View More",
    noCategory: "No Category",
    searchFor: "Search Results For",
  },
};

export const carriers = {
  en: {
    title: "We support 1000+ Carriers and postal services worldwide.",
    para: "ShipVista supports shipment tracking for the following Postal and Carrier services worldwide.",
    searchInputPlaceholder: "Search a carrier",
    footerText: "Don't see your carrier listed? Contact",
    email: "customercare@shipvista.com.",
  },
};

export const carrierDetails = {
  en: {
    title: "Tracking System",
    trackingNumber: "Tracking Number",
    btnText: "Track Your Shipment",
  },
};

export const pricing = {
  en: {
    title: "Scalable Plans and Pricing For Your Business",
    para: "Shipping solutions built for retailers at every stage of their business. Choose a plan that fits your needs, Upgrade, downgrade or cancel at any time.",
    yearly: "Yearly",
    monthly: "Monthly",
    alwaysFree: "ALWAYS FREE",
    paid: "Paid Plans",
    recommended: "RECOMMENDED",
    signUp: "SIGN UP",
    para2: "* Price is subject to change as features are added and changed",
    coreFeatures: "Core Features",
    advanceFeatures: "Advanced Features",
    customizable: "Customizable",
    custDesc:
      "You need to ship over 10,000 shipments per month. Please contact us for more",
    contactUs: "CONTACT US",
    custFeatures: [
      "10,000+ Shipments/mo.",
      "Unlimited Carrier Accounts",
      "1-10+ User(s)",
    ],
    contactWithUs: "CONTACT WITH US",
    faq: "Frequently Asked Questions",
    faqPara:
      "Take a look at the most commonly asked questions regarding our plans.",
    faqPricing: "Other FAQ's Related to Pricing",
    faqPara2: "Can't find what you are looking for?",
    reachOut: "Reach out to us.",
    email: "mailto:customercare@shipvista.com",
  },
};

export const plan = {
  en: {
    subscriptionPlan: "Subscription Plan",
    price: "Price",
    core: "Core",
    advanced: "Advanced",
    priceInfo: "Price Information",
    term: "Term",
    default: "Default",
    promo: "Promo",
    faq: "FAQ",
    para1:
      "Price breakdown of this plan including monthly and yearly price as well as promos.",
    planFeatures: "Plan Features",
    coreFeatures: "Core Features",
    features: "Features",
    advanceFeatures: "Advanced Features",
    para2:
      "The core features of our app that are included in this plan (not all core features are listed)",
    faqTitle: "Frequently Asked Questions",
    faqPara1:
      "Take a look at the most commonly asked questions regarding our plans.",
    faqPara2: "Can't find what you are looking for?",
    reachOut: "Reach out to us.",
    email: "mailto:customercare@shipvista.com",
    yearly: "Yearly",
    monthly: "Monthly",
    para3:
      "Advanced feature included with this plan such as API access (not comprehensive)",
  },
};

export const becomeAPartner = {
  en: {
    title: "Become a ShipVista Partner",
    title2: "Apply to be a part of the ShipVista Partner Program",
    para2:
      "Work with ShipVista and offer your expertise to a growing list of merchants.",
    btn1Text: "BECOME A PARTNER",
    title3: "Our Partner Ecosystem",
    card1Title: "Technology Partners",
    card1Para:
      "E-commerce and Marketplace technologies that we've partnered with to provide our services to merchants",
    card1BtnText: "Learn More",
    card2Title: "Fulfillment Partners",
    card2Para:
      "Choose from a variety of partnered carriers to ship with using ShipVista",
    card2BtnText: "Learn More",
    title4: "Why Join Our Program?",
    grid1Title1: "Boost Your Revenue",
    grid1Para1:
      "You'll gain a new source of revenue that you can use to reinvest in your business",
    grid1Title2: "Be part of a growing eco-system",
    grid1Para2: "We are constantly evolving and so are our partnership program",
    grid1Title3: "Access to support",
    grid1Para3:
      "As part of our partnership program, we offer top quality support to all our partners",
    formTitle: "Ready to get started?",
    formPara: "Fill out the form to join now",
    firstName: "First Name",
    lastName: "Last Name",
    companyEmail: "Company Email",
    companyName: "Company Name",
    phoneNumber: "Phone Number",
    optional: "optional",
    typeOfBusiness:
      "Type of your business / how you would like to work with ShipVista ",
    pleaseSelect: "Please Select",
    locationOfAudience: "Location of audience ",
    comment: "Comments",
    applyNow: "Apply Now",
  },
};

export const becomeAnAffiliate = {
  en: {
    title: "Become an Affiliate Today and Start Receiving Benefits!",
    para: "If you join ShipVista's affiliate program, you could benefit from commissions on each visitor that sign's up to our service when referred by you using a link.",
    title2: "Note",
    para2:
      "We are currently harmonizing our program to offer more benefits to our affiliates and the details on this page will soon be updated.",
    subHeading2: "COMMISSION",
    subPara2: "During the term of this Agreement, we will pay you as follows;",
    list2: [
      "Earn a $0.10 per label commission for every shipment sent by your referrals for the first month using our Shipvista.com's default carrier accounts, including Canada Post, UPS, USPS, and DHL Express among others.",
      "Earn a $5.00 commission for each New REFERRALS that sign up with any of our Paid Subscription Plan, including Professional, Enterprise, and customizable Plans among other paying plans.",
    ],
    newCommissionProgram: "New Commission Program T&Cs",
    title3: "Old Program",
    subHeading3: "What's Affiliate Program?",
    para3:
      "Earn money without having to actually sell anything! You don't even need a website! Earning money is so easy with our affiliate program, promote Shipvista services on your website, blog, social media or any online location and receive commission on deposit you successfully refer.",
    readyToGetStarted: "Ready to get started?",
    getStartedPara:
      "Click the following link to sign up and join the program now.",
    signUpNow: "SIGN UP NOW",
    title4: "How Does ShipVista's Affiliate Program Work?",
    list4: [
      "Affiliates promote Shipvista's services with referral links on their own web page or any social media.",
      "People click the referral links, get directed to shipvista.com and sign up as a user -> First deposit you will get commission.",
      "Affiliates earn 10% of first deposit as commission.",
    ],
    subHeading4: "Customer Deposits $1000",
    subHeading4_2: "You will get $20",
    title5: "Why Choose ShipVista?",
    list5: [
      "Competitive tiered commission rate.",
      "High conversion rate.",
      "Monthly extra bonus for the best affiliates who generates the most refer.",
      "High-quality Service with best price at Shipvista.",
      "Exclusive Banners, link and text links available.",
    ],
  },
};

export const overview = {
  en: {
    title: "An Integration That Drives The Latest In E-commerce",
    btn1Text: "BECOME A DEVELOPER",
    title2: "Easily get access to data that you need in one place",
    labels: "Labels",
    rates: "Rates",
    orders: "Orders",
    profiles: "Profiles",
    purchases: "Purchases",
    products: "Products",
    shipments: "Shipments",
    stats: "Stats",
    other: "Other",
    title3: "Taking the frustration out of dealing with shipping complexity",
    para3:
      "With our API you don't have to deal directly with that troubles that come with managing and tracking shipments with several different carriers",
    title4: "Meets industry standard reliability",
    para4:
      "You can depend on it to build your platform without any bugs and almost near-zero downtime. Get access to what you need 24/7.",
    title5: "Benefits of using our API",
    para5:
      "There are several reason why you could gain from using our building on our infrastructure not just access to data.",
    subHeading1: "Well Documented, Supported API",
    subPara1:
      "We have taken extra care to provide a comprehensive, always up-to-date, easy to understand documents",
    subHeading2: "Versioning support",
    subPara2:
      "We make sure to provide access to previous versions as updates are made and always publish the changes between each version in the docs",
    subHeading3: "Simplified Integration",
    subPara3:
      "Care has been taken to reduce the complexities of collecting the data that is needed to unifying them in and easy to access format",
    subHeading4: "More",
    subPara4: "There are many more benefits that aren't listed...",
    more: "More",
    title6: "Developer FAQ's",
    faq: [
      {
        title: "Can't find the answer to your question?",
        desc: "Try searching for what you need in our Help Center or get in touch with our team",
      },
      {
        title: "Can I try ShipVista before committing to a plan?",
        desc: "Yes! Most patron starts out using the basics of ShipVista via our Starter (Always Free) plan, completely free of charge: you only pay for buying pre-negotiated shipping labels for your shipment from ShipVista Default Carriers - as you would any shipment, but cheaper.",
      },
      {
        title: "Want to try more features?",
        desc: "All paid ShipVista plans come with a free trial period.",
      },
      {
        title: "How does the Starter (Always Free) plan work?",
        desc: "Whether you're a startup or a conglomerate, we want ShipVista to be available to anyone. Smaller stores can start for free with competitive and discounted pre-negotiated shipping rates using our Starter (Always Free) plan. ShipVista supports you through your entire business lifecycle - adding more features and lowering the rates as your business grows. The highest plan has the best shipment rates, and if you use a paid plan, we also offer the service to connect your own carrier contracts and rates. This way you always have the best pre-negotiated shipping rates for your store.",
      },
      {
        title: "Can I change my plan later on?",
        desc: "Absolutely! All our plans are scalable and adjustable. You can upgrade, downgrade or cancel at any time.",
      },
      {
        title: "How does the subscription invoicing work?",
        desc: "For all paid plans, you will receive an invoice once a month for the subscription. Invoices are auto-billed via recurrent billing and charged to the credit card on file. All our plans are scalable. You can upgrade, downgrade or cancel at any time.",
      },
      {
        title:
          "Want to use your own carrier contracts and rates instead of ours?",
        desc: "If you use a paid ShipVista plan, that's no problem. This way you always have the best rates through your own carriers and you only pay us a monthly subscription fee. Neat, right?",
      },
      {
        title: "How to buy or pay for postage or a shipping label?",
        desc: "When shipping via our pre-negotiated Default Carriers rates you will get charged upon your shipping labels being generated. Shipvista uses a wallet system where you can deposit funds (SVCash) to buy postage or pay for shipments. We also use this wallet to give you offers and bonuses as you become eligible for it",
      },
      {
        title: "What Are ShipVista 's Default Carriers?",
        desc: "By default, ShipVista offers pre-negotiated shipping rates for Canada Post, UPS, and More without any setup required. Customers that use these rates will avoid all monthly per-label service fees. You're welcome to add your own carrier accounts for any carriers that ShipVista supports with one of our eligible Subscription plans.",
      },
      {
        title: "When will I be charged?",
        desc: "We will not charge you a dime unless you upgrade your subscription. If you want to upgrade to a ShipVista subscription, we'll bill you at the end of your 30-day free trial for the plan that you choose.",
      },
      {
        title: "What counts as a shipment?",
        desc: "Any shipping label that is generated through ShipVista (including return labels), any external fulfillment like 'mark as shipped' or FBA order processed through ShipVista is considered a single shipment. Reprinting a prior shipping label is not counted as an additional shipment, but re-shipping an order (as in, generating a new label) is counted.",
      },
      {
        title: "What type of support do you offer?",
        desc: "We offer free support to all of our subscribers and users via our e-mail help desk, live webinars, and extensive knowledge base. Our techs are available during local business hours, and we're always monitoring ShipVista for any emergency issues. For any support feel free to contact us.",
      },
      {
        title: "Is there a fee to connect extra selling channels?",
        desc: "Nope, Nothing. Zero. Zilch. Nada. Our mission is to make you efficient at fulfilling your orders on time - wherever you sell. We don't think it's right to charge you more if you want to use multiple selling channels to grow your sales.",
      },
      {
        title: "What marketplaces and shopping carts do you support?",
        desc: "We strive to be there for wherever you sell and however you ship, so we're always working towards having every selling channel solution ever. For a full list of our partners, check out this page",
      },
    ],
  },
};

export const becomeADeveloper = {
  en: {
    title: "Sign Up as a developer to start using our API",
    form: {
      firstName: "First Name",
      lastName: "Last Name",
      companyEmail: "Company Email",
      companyName: "Company Name",
      phoneNumber: "Phone Number",
      optional: "Optional",
      businessType: "How you would like to work with ShipVista *",
      location: "Location of audience *",
      comments: "Tell us more about your service (optional)",
    },
    title2: "What is the Developer Partner Program?",
    para2:
      "Our Developer Partner Program is for teams or individuals who are interested in making apps or integrations that use the ShipVista API to extend our services and reach out to larger user base. The program is completely free and you will be working with the Developer Partner Team who will be helping you with everything from learning about the how to use the APIs to testing.",
    applyNow: "APPLY NOW",
  },
};

export const apiStatus = {
  en: {
    title: "API Status",
    summary: "Summary",
    system: "System",
    currentStatus: "Current Status",
    platformApi: "Platform API",
    carrierApi: "Carrier API",
    webDashboard: "Web Dashboard",
    restApi: "REST API",
    allSystems: "All Systems",
    operational: "Operational",
    maintenance: "Maintenance",
    noSchedule: "No upcoming scheduled maintenance",
    pastIncidents: "Past Incidents",
    noIncidents: "No incidents during this time period",
    total: "Total",
    loadmore: "Show More",
    showless: "Show Less",
  },
};

export const openAccountOffer = {
  en: {
    title: "Welcome Offer",
    openAccountOffer: "Open Account Offer",
    matchBonus: "100% Match Bonus",
    para1: "Open an account today and claim your 100% Deposit Match Bonus.",
    para2:
      "In order to qualify for your bonus, please follow these simple instructions:",
    para3:
      "As part of signing up, first time customers are entitled to 100% match bonuses on initial deposits (qualifying deposits of $10 or more) up to $1000.",
    subHeading1:
      "To qualify for your match bonus, ShipVista.com recommends you check these offer terms:",
    list: [
      {
        title: "Minimum deposit of $10:",
        desc: "Make a qualifying deposit of $10 or more and receive a 100% Deposit Match Bonus up to $1000. If your qualifying deposit is $1000 more then you will only qualify for a bonus of $1000.",
      },
      {
        title: "Spending requirement:",
        desc: "Spend 3x the qualifying deposit to make your bonus amount usable.",
      },
      {
        title: "",
        desc: "Your qualifying deposit is your first deposit or the largest payment made 7 days prior to claiming bonus.",
      },
      {
        title: "Match the Highest Deposit Amount:",
        desc: "Make multiple deposits prior to claiming the bonus and we will choose your largest deposit.",
      },
      {
        title: "Bonus qualification period:",
        desc: "Make first or multiple deposits 7 days before bonus activation.",
      },
      {
        title: "",
        desc: "Once you claim your offer, we will send a notification when the deposit bonus is available for use.",
      },
      {
        title: "",
        desc: "This sign-up bonus is only offered to new customers.",
      },
      {
        title: "",
        desc: "Maximum bonus capped at $1000.",
      },
      {
        title: "",
        desc: "Valid for one time use only.",
      },
    ],
    btn1Txt: "SIGN UP FOR FREE",
    faqTitle: "Frequently Asked Questions",
    faqPara:
      "Take a look at the most commonly asked questions regarding our Welcome Offer.",
    lastUpdated: "Last Updated",
    date: "February 1st, 2022",
    faq: [
      {
        title: "Can I use my bonus on my first shipment?",
        desc: "No, That's not possible as the spent rule has not been met.",
      },
      {
        title: "How soon after I sign up can I begin shipping?",
        desc: "You can begin shipping immediately.",
      },
      {
        title: "How much should I spend to be eligible?",
        desc: "Spend 3x the qualifying deposit to make your bonus amount usable.",
      },
      {
        title: "Is there a minimum deposit?",
        desc: "Yes, Make a qualifying deposit of $10 or more",
      },
    ],
  },
};

export const featuresPage = {
  en: { titleText: "ShipVista Features", subTitle: "" },
};

export const airMilesInfo = {
  en: {
    title: "AIR MILES Offers",
    ctaText: "See More Details",
  },
};

export const introductions = {
  en: {
    para1: "Greeting Patron and fellow entrepreneurs.",
    para2:
      "I'm Kelvin Oben, Pioneer at ShipVista.com. My team and I specialize in Powering your eCommerce Shipping infrastructures, Order Fulfillment, and Customer Returns for businesses, via our Shipping Platform ShipVista.com. I’d like to personally invite you to sign up and try our shipping Platform for free.",
    para31: "Get 10 ",
    para32:
      "at signup and up to 40+ free shipments with our New customer's $1000 Matched shipping credit offer.",
    para41:
      "As an eCommerce entrepreneur, we are aware that, 45% of your total cost is incurred on shipping. meanwhile, it's only 10% of the total cost for larger businesses. That's why We established ShipVista.com in order to level the playing field in eCommerce shipping, such that partners like you can Leverage the Same Inventory and Order Fulfillment Technology Used By eCommerce Leaders, without Breaking the bank. We have pre-negotiated up to 89% off shipping costs with ",
    para42:
      ", and much more to save you money. However you ship. For lightweight or heavy items, creating discounted shipping labels via our platform is easy. You can also Bring Your Own accounts(BYOA) with the above carriers and use our technology for a 1-Year Free subscription with Promo Code: SUMMER22. Eliminate Post Office trips & Never pay full price again. No more manual label creation. Use automation and print labels in seconds, with 1 click.",
    para51:
      " Let's fix your abandonment cart issues with our Live shipping cost calculator Plugin for",
    para52:
      ". Display shipping rates to customers on your website during checkout.",
    para6:
      "I’d love to hear what you think of ShipVista.com and if there is anything we can improve. I’m always happy to serve!",
    para71: "Read up on all the latest features on our",
    para72: "plus don't forget to review our",
    para73: "Videos.",
    para8: "Have a blissful week!",
    para9: "Thank you for shipping with us",
    para10: "We are here to serve.",
    link1: "Air miles",
    link2: "Canpar",
    link3: "Canada Post",
    link4: "UPS",
    link5: "Shopify",
    link6: "WooCommerce",
    link7: "blog",
    link8: "quick help",
  },
};

export const invitation = {
  en: {
    title: "An Invitation to try ShipVista.com for free",
    subTitle: "",
    intro: "INTRODUCTION",
    header1: "AIR MILES Offer",
    header2: "FEATURES",
  },
};

export const howItWorksPage = {
  en: {
    title: "How It Works",
    list: [
      {
        title: "Creating Your Shipment",
        para: "To create a shipment enter a new address or search your autocomplete address book will suggest correct address then simply fill in the details for your shipment and delivery instructions.",
        img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/how-it-works/enter-ship-from-address.png",
      },
      {
        title: "Choose Your Service",
        para: "Once you have entered shipment information you will be able to select from available delivery options. Each delivery option will include a delivery date, standard pricing, and reduced pricing from ShipVista.",
        img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/how-it-works/rates-appear.png",
      },
      {
        title: "Print Your Documents",
        para: "Once you have selected the best options for your shipment, print your documents and schedule a pick up for your package - your shipment will be picked up by the courier you selected for your shipment.",
        img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/how-it-works/shipping-label-dialog.png",
      },
      {
        title: "Schedule A Pickup",
        para: "Once your package is ready for shipment you can easily schedule a pickup. No matter how many packages or service levels you select you are only 2 clicks away from scheduling a pickup. And your package will be picked up by the carrier that you've chosen for delivery.",
        img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/how-it-works/schedule-pickup.png",
      },
      {
        title: "Track Your Package",
        para: "Tracking your package is as easy as logging in to your ShipVista account or homepage Your delivery status, date and package location will be shown.",
        img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/how-it-works/track-shipment.png",
      },
    ],
  },
};

// export const about = {
//   en: "",
// };

export const aboutUs = {
  en: {
    bannerTitle: "We make it easier to manage shipments",
    bannerSubTitle:
      "is a smart multichannel order management software and fulfillment solution for online Retailers to save money, save time and increase sales.",
    link1: "Product",
    link2: "Partners",
    link3: "Benefits",
    link4: "FAQ",
    section1Title:
      "A more enjoyable experience is just a few clicks (or taps) away",
    section1Para1:
      "ShipVista.com is an all-in-one multichannel shipping platform that offers real-time carrier rates, automated print shipping labels, and powerful tools that allow e-commerce businesses, platforms, online marketplaces, and sellers to integrate shipping with multiple carriers through our API and web application to manage their operations more efficiently.",
    section1Para2:
      "Our Multi-Carrier Shipping web-based application automates, enhances, and streamlines the shipping experience of eCommerce merchants, by helping online retailers process and ship their orders using multiple carriers. Our Affordable Web-Based Shipping Software Makes eCommerce Order Fulfillment Easier.",
    section1Btn: "Sign Up for Free",
    section2Title: "What Retailers Can Do On Our Platform",
    section2Title1: "CONNECT YOUR STORE",
    section2Title2: "CREATE DISCOUNTED SHIPPING LABELS",
    section2Title3: "TRACK SHIPMENTS & NOTIFY CUSTOMERS",
    section2Title4: "STREAMLINE RETURNS",
    section2Title5: "What We Offer",
    section2Para1:
      " Sync all of your sales channels to easily manage orders in one place. (65+ marketplaces including Walmart Canada, eBay, Etsy, Amazon, and Shopify)",
    section2Para2:
      "Get the lowest possible rates from Canada Post, USPS, UPS, FedEx, DHL, and more.",
    section2Para3:
      " Tracking and notifications to keep you and your customers up-to-date.",
    section2Para4: "Generate return labels automatically, for free.",
    section2Para5:
      "When using Shipvista's web-based interface, retailers can process and ships their orders using multiple carriers, customers can compare shipping rates and easily select the lowest cost carrier for each package. All order data is automatically backed up in the cloud and is accessible from any computer.",
    section2Para6:
      "If you are searching for competitive shipping rates, and or Multi-Carrier order management software, you have come to the right place. When you sign-up to access our shipping system, your business is well on its way to simplifying the shipping process and enjoying access to preferential shipping rates. Whether your business is based in the United States or Canada, shipping is fast, simple, and convenient with Shipvista.com.",
    section2Para7:
      "Eliminate the time spent searching for shipping rates from multiple carrier sites to determine the best option and services required for your business. Enjoy a best-in-class, all-in-one solution to obtain instant shipping quotes, book shipments, track shipment status, and manage your shipment spending.",
    section3Title1:
      "Partnered with several technology platforms, and carriers to provide our services",
    section3Para1:
      "There is a chance that we have partnered with your preferred carrier, e-commerce platform or 3PL provider.",
    section4Title1: "Other Benefits",
    section4List: [
      "New Customer Sign up bonus (Up to $1000 shipping credit)",
      "Save up to 89%* on postage across marketplaces with negotiated rates, or use your own",
      "Connect shipping to your Accounting and CRM tools",
      "No subscription fee for eligible users (more than $550 retail value)",
    ],
    section5Para1: "Commonly asked questions about ShipVista.",
    section5Para2: "Can't find what you are looking for?",
    section5Link: "Reach out to us.",
    faqTitle: "Frequently Asked Questions",
    section5List: [
      {
        question: "Can I Change My Account?",
        answer:
          "Yes. You can change your account plan by going into the Subscription section of the dashboard in the account settings.",
      },
      {
        question: "How Can I Upgrade My Account?",
        answer: "To upgrade your account, navigate to the dashboard.",
      },
      {
        question: "Any Other Fees?",
        answer: "No there are no fees for changing you account type.",
      },
      {
        question: "What are ShipVista's Default Carriers?",
        answer:
          "By default, ShipVista offers discounted rates for all it's carriers",
      },
    ],
    section6Cards: [
      {
        title: "See how our product works",
        para: "Its deceptively easy to use and you can seeing how it works in a few simple steps.",
        link: "Learn More",
      },
      {
        title: "Contact Sales for questions",
        para: "You might still have some questions about what we do and our product. Don't worry, we'll be glad to answer.",
        link: "Learn More",
      },
      {
        title: "Read about our blog.",
        para: "We post a lot of updates, new, and interested details in our blogs. Come see.",
        link: "Learn More",
      },
    ],
  },
};
export const documentToolKit = {
  en: {
    title: "DOCUMENT TOOLKIT",
    list: [
      {
        title: "B13A Form - Export Declaration",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/b13a-ExportDeclaration.pdf",
      },
      {
        title: "NAFTA Certificate of Origin",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/NAFTA-Certificate-of-Origin.pdf",
      },
      {
        title: "Commercial Invoice Online Form",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/commercialinvoice.pdf",
      },
      {
        title: "Proforma Invoice",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/Proforma_Invoice.pdf",
      },
      {
        title: "DRAM form for the US",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/Dram_Certification.doc",
      },
      {
        title: "FCC Radiation form for the US",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/FCC_Radiation_Form_US.pdf",
      },
      {
        title: "Dangerous Good Document",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/DangerousGoodDocument.pdf",
      },
      {
        title: "USMCA - Certificate of Origin",
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/document-toolkit/USMCA-Certificate-of-Origin-Form-Sample-May-8-2020.pdf",
      },
    ],
  },
};

export const contactSales = {
  en: {
    buttonText: "Connect With Sales",
    title: "Connect With Sales",
    subTitle1: "Simply fill out the information below and you",
    subTitle2: "will be contacted by a member of our sales team",
    businessTypeData: [
      "Seller/merchant",
      "eCommerce Platform",
      "Fulfillment",
      "Marketplace",
      "Logistics Provider (WMS, IMS, etc)",
    ],
    monthlyShippingVolume: ["0-999", "1000-4999", "5000-9999", "10000+"],
    helpSubject: [
      "API",
      "Getting Started",
      "Rates and Pricing",
      "Store and Platform Integrations",
      "Errors with Website",
      "Other",
    ],
    textFields: {
      name: {
        label: "Name",
        placeholder: "Your Name",
      },
      company: {
        label: "Company Name (optional)",
        placeholder: "Your company name",
      },
      phone: {
        label: "Phone",
        placeholder: "Your phone number",
      },
      email: {
        label: "Email",
        placeholder: "Your Email",
      },
    },
    selectArray: {
      business: {
        label: "What type of business do you have?",
      },
      shippingVolume: {
        label: "What's your monthly shipping volume?",
      },
      help: {
        label: "How can we help you?",
      },
    },
    accountNumber: {
      label: "Your Shipvista Account Number (optional)",
      placeholder: "Your Account Number",
    },
    radiosAndCheckboxes: {
      caPost: {
        label: "CanadaPost",
      },
      ups: {
        label: "UPS",
      },
      fedEx: {
        label: "FedEx",
      },
      dHL: {
        label: "DHL",
      },
      other: {
        label: "Other",
        placeholderBig: "What (other) carriers are you using?",
        placeholderSmall: "Other Carriers",
      },
    },
    textAreaArray: {
      additional: {
        placeholder:
          "Please add any additional details here so we can match you with the right person",
      },
    },
  },
};

export const contactSupport = {
  en: {
    title1: "CONTACT US",
    para1: "SEND US AN EMAIL",
    title2: "Contact Details & Your Message",
    para2: "Please fill out the form below to contact us",
    subject: "Subject",
    fullname: "Full Name",
    email: "Email",
    phone: "Phone Number (Optional)",
    company: "Company Name (Optional)",
    message: "Message",
    title3: "OUR OFFICE",
    title4: "SALES TEAM",
    title5: "CUSTOMER CARE",
    title6: "BUSINESS HOURS",
    title7: "BILLING",
    title8: "TECH SUPPORT",
  },
};

export const contactUs = {
  en: {
    title: "What Can We Help You With?",
    subTitle: "Choose any of the options below for help  related to that topic",
    cards: [
      {
        title: "Sales",
        path: "/contact/sales",
        svgId: "sales",
        description:
          "Anything related to our product including pricing, promotions, or fees.",
      },
      {
        title: "Support",
        path: "/contact/support",
        svgId: "support",
        description:
          "Send an email to us directly or give us a call. We are always happy to help.",
      },
      {
        title: "Dev Center",
        path: "/developers",
        svgId: "developers",
        description:
          "All things related to our API such as documentation, tutorials, and guides.",
      },
      {
        title: "Help Center",
        path: "/help",
        svgId: "help",
        description:
          "All things related to FAQ, plus general guides such as how to setup your account.",
      },
    ],
  },
};

export const shipvistaForPlatforms = {
  en: {
    title: "ShipVista For Platforms",
    title2: "Connect Your Tool or Plugin Using ShipVista",
    para2: "Use your favorite tools and plugins to enhance your experience",
    search: "Search",
    featured: "Featured",
    eCommerce: "E-Commerce",
    learnMore: "Learn More",
    faqsTitle: "FAQs",
    faqs: [
      {
        title: "What is your refund policy if a plugin doesn't work?",
        desc: "100% Money back guarantee.",
      },
      {
        title: "Can you configure these plugins? Is it complicated?",
        desc: "Yes. The plugin is very easy to configure. We have a step by step tutorial on setting up this plugin. Our Help Desk also has extensive documentation which includes FAQs, Troubleshooting Guide, Knowledge Base, and Code snippets.",
      },
      {
        title:
          "Do you provide support for configuring a product and help resolve issues if any?",
        desc: "Yes! In case you need assistance, open a ticket at our Help Center. We usually respond within 24 hours. However, in most cases, our Help Center articles will help to solve the issue faster.",
      },
      {
        title: "While updating a plugin, Will it keep the settings?",
        desc: "Yes. It will keep settings. Please check our documentation explaining the procedure to install and update our plugin.",
      },
      {
        title: "How do I add these plugins?",
        desc: "Instructions about how to add these plugins can be found on their pages.",
      },
      {
        title: "How often are these plugins updated?",
        desc: "We update the plugins regularly. Please check the Changelog tab for the update history.",
      },
    ],
    footerPara:
      "Don't see the solution you are looking for? Send your feedback to",
    email: "customercare@shipvista.com",
  },
};

export const platform = {
  en: {
    with: "with",
    shipVista: "Shipvista",
    note: "Note",
    description: "Description",
    changeLog: "Change Log",
    faqs: "FAQs",
    screenshots: "SCREENSHOTS",
    whyShipvista: "WHY CHOOSE SHIPVISTA’S LIVE SHIPPING RATES",
    mainFeatures: "MAIN FEATURES OF SHIPVISTA LIVE SHIPPING RATES",
    pluginWorks: "HOW DOES SHIPVISTA LIVE SHIPPING RATES PLUGIN WORK?",
    whyShipvistaAccount: "WHY DO I NEED A SHIPVISTA.COM ACCOUNT?",
    needHelp: "NEED HELP WITH SHIPVISTA PLUGIN?",
  },
};

export const quickVideos = {
  en: {
    title: "Quick Videos",
    title2: "Getting Started",
  },
};

export const airmilesContest = {
  en: {
    contests: "Contests",
    airMiles: "AIR MILES® Reward Miles™",
    title: "AIR MILES® Reward Miles™",
    hero: {
      date: "February 15, 2023 - April 16, 2023",
      title: "Enter for a chance to win 2500 AIR MILES® Reward Miles™*",
      para: "When you sign up for an account on ShipVista or Link your AIR MILES® Reward Miles™ number to an existing Account",
    },
    entering: "ENTERING IS EASY",
    signUp: "SIGN UP OR LOGIN",
    linkYourCard: "LINK YOUR AIR MILES CARD",
    linkYourCardPara:
      "to your ShipVista account by April 15, 2023 to enter for a chance to WIN!",
    alreadyHaveAnAccount: "Already have a ShipVista account?",
    dontHaveShipvistaAccount: "Don't have a ShipVista account?",
    imgFooter: "*(2 prizes of 2500 AIR MILES® Reward Miles™)",
    linkNowBtnText: "Link Now",
    signUpBtnText: "Sign Up and Link",
    details: "Details",
    detailsList: [
      {
        title: "Who is eligible?",
        list: "Any ShipVista customer",
      },
      {
        title: "How to enter?",
        list: "Add your AIR MILES collector card number during the contest period.",
      },
      {
        title: "What information will be collected?",
        list: "Just your collector card number is collected.",
      },
      {
        title: "When does the contest start?",
        list: "Look in the terms for contest start, end, and duration details.",
      },
      {
        title: "Can I connect more than once?",
        list: "No, only one card number per ShipVista account.",
      },
      {
        title: "Where can I find the terms?",
        list: "Look at the info below",
      },
    ],
    title2: "HOW TO ENTER (AFTER LOGGING IN)",
    images: [
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/open-username-dropdown-2.png",
        desc: "Click your user profile icon at the top right hand corner of the window",
      },
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/click-air-miles-2.png",
        desc: "Click the AIR MILES icon that appears in the popup on the top right hand corner.",
      },
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/air-miles-page-2.png",
        desc: "You will be presented with a page where you can see all account-related AIR MILES settings.",
      },
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/air-miles-card-unfilled-2.png",
        desc: "On the page, you will see an AIR MILES collector card image. Click the 'Connect your Account' button on the AIR MILES card.",
      },
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/click-link-account-2.png",
        desc: "A dialog will open with a form to enter your AIR MILES card details. Fill in the form.",
      },
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/enter-details-2.png",
        desc: "After filling in the form with the correct details, click the 'Connect' button to connect your AIR MILES account with your ShipVista account.",
      },
      {
        url: "https://cbpstaticfiles.blob.core.windows.net/sv-app/help-images/air-miles/air-miled-card-added-2.png",
        desc: "After clicking connect, the two accounts will be linked. The AIR MILES card on the page will now show the updated information.",
      },
    ],
    termsText: "Terms and Conditions",
    terms: {
      list: [
        {
          title: "ELIGIBILITY",
          para: [
            "The Contest is open only to legal AIR MILES collector who have reached the age of majority on the date that they entered the Contest. Void where prohibited by law. Employees, directors, and officers of the Administrator, ShipVista Corporation. (The “Administrator”) and the Sponsor, ShipVista Corporation. (the “Sponsor”) and its parent companies, affiliates, franchisees, subsidiaries, distributors, representatives, advertising and promotional agencies, agents, sponsors, and any entity that they contract with specific to the Contest, as well as the immediate family members, and any persons domiciled with any of the above (whether related or not), are not eligible to win the prize as set out below.",
          ],
        },
        {
          title: "TIMING",
          para: [
            "Contest runs from 12:00:01 AM on February 15th, 2023 and ends at 11:59:59 PM on April 15th, 2023 (the “Contest Period”).",
          ],
        },
        {
          title: "HOW TO ENTER",
          para: [
            "To enter the Contest, you must Sign Up for a shipvista.com account by visiting https://shipvista.com/sign-up and opt in to receive ShipVista.com communications by email (https://shipvista.com/settings), and/or if you already have a ShipVista.com, simply log into your ShipVista.com account and opt in to receive your ShipVista.com communications by email (https://shipvista.com/settings) (each an “Entry”). There is a limit of one (1) Entry per person.",
          ],
        },
        {
          title: "NO PURCHASE NECESSARY",
          para: [
            "To receive one (1) Contest entry by mail or without signing up for on the shipvista.com account, an entrant must submit via Mail with his or her first and last name, complete mailing address including city, province, postal code, daytime phone number (including area code), email address, and AIR MILES card number (an “Entry”), and mail to: ShipVista Corporation., Attn: SV Loyalty Marketing Dept., U9, 9 Royalcrest Rd Etobicoke, ON M9V 2L6 (with “AIR MILES Sign-Me-Up in Contest” in the subject line of the letter). The letter must be received by Contest Sponsor no later than 11:59:59 p.m. ET on April 15th, 2023 to be entered in the Contest.",
          ],
        },
        {
          title: "PRIZE DESCRIPTION",
          para: [
            "Contest entrants are entered for a chance to win one of two (2) prizes of 2,500 AIR MILES® Reward Miles (the “Prize”). The Prize has no equivalent cash value, is non-transferable and no substitutions will be made. The Prize must be accepted as awarded. The Sponsor reserves the right to substitute the Prize for one of equal or greater value for any reason. Entrants are responsible for all costs not expressly described as being included as part of the Prize, such as any fee associated with the receipt and/or use of the Prize. Please allow up to ten (10) weeks for delivery or fulfillment of the Prize.",
            "The approximate retail value of an AIR MILES Reward Miles prize depends on the chosen method of redemption, available reward options at the time of redemption, and the set preference between AIR MILES Cash and AIR MILES Dream accounts. If redeemed with AIR MILES Cash, 95 Cash Miles can be used in-store for $10 towards purchases at participating AIR MILES partners or 95 Cash Miles can be used online for eVouchers for $10 worth of value at participating reward partners. If redeemed for flights, value depends on the current marketplace price of the chosen flight, which will vary. Winner must pay applicable taxes, related transportation fees, governmental levies, excess baggage and other non-ticket costs. The value of AIR MILES Reward Miles used for non-flight reward options depends on reward options in effect at the time of redemption. AIR MILES Reward Miles prize is subject to the Terms and Conditions of the AIR MILES Reward Program as amended from time to time. AIR MILES Reward Miles prize is not transferable or convertible to cash and must be accepted as awarded.",
          ],
        },
        {
          title: "ODDS",
          para: [
            "The odds of winning are dependent on the total number of eligible entries received during the Contest Period.",
          ],
        },
        {
          title: "DRAW DETAILS",
          para: [
            "Two (2) Prizes of 2,500 AIR MILES® Reward Miles: Two (2) random draws will occur at the Administrator’s office at U9, 9 Royalcrest Rd Etobicoke, ON M9V 2L6, from all eligible entries received during the Contest Period as applicable (the “Prizes Draw”). The draws will be conducted five (5) days after the end of the contest (April 15th, 2023). You do not need to be in attendance to be selected.",
          ],
        },
        {
          title: "WINNER CONTACT DETAILS, RELEASE AND SKILL TESTING QUESTION",
          para: [
            "f you are chosen to be eligible to win a Prize, you will be contacted within thirty (30) days of the Draw at the email address recorded in respect of your ShipVista.com account. If you have not provided an email address you are not eligible to win a prize. You must be email contactable by ShipVista.com and have a valid opt-in to communications on your ShipVista.com account unless entering via the No Purchase Necessary option. In order to be declared a winner, you will be directed to complete a Release Form which will be sent through email. You must then correctly answer without assistance a mathematical skill testing question and sign the Release form (the “Release”) and return your answer and executed Release within ten (10) days to the Contest Administrator at _____________ [email]. Upon verification of the completion and correctness of the answer to the skill-testing question, and execution of the Release, you may be declared a winner. In case of a dispute concerning the identity of the individual who submitted an automatic entry with purchase, the entrant will be deemed to be the account holder of the AIR MILES® collector account under which the entry was submitted.",
          ],
        },
        {
          title: "FORFEIT OF PRIZE",
          para: [
            "If you cannot be reached within seven (7) days of our first attempt to contact you, do not answer the skill testing question correctly, or otherwise fail to comply with these Contest Rules, then the Prize will be forfeited and another Entry will be randomly selected from among the remaining eligible entries as per these Contest Rules. This process of selecting a Prize winner will be repeated until the Prize eligible to be won is awarded.",
          ],
        },
        {
          title: "USE OF PERSONAL INFORMATION",
          para: [
            "By entering the Contest and voluntarily providing your personal information as described in these Contest Rules, you agree to the collection, use and disclosure by the Administrator (and where applicable, the Sponsor), and its respective employees and/or authorized agents, of your personal information, for the purpose of administering the Contest, including but not limited to, contacting you with respect to the Contest if you are a selected entrant. Personally identifiable information will only be used to administer the Contest and for no other purpose, except as specifically outlined in these Contest Rules. Personally identifiable information will not be sold, shared or disclosed by the Administrator to any third party, other than to the Sponsor or a third party engaged by the Administrator or Sponsor for the purpose of administering the Contest, or if required by law with the exception that aggregated information may be used by or shared amongst the Administrator and its subsidiaries and affiliates, or shared by the Administrator with third parties.",
          ],
        },
        {
          title: "PUBLICITY CONSENT",
          para: [
            "By entering the Contest, you agree that if you are determined to be a winner, the Administrator and the Sponsor may use your name, comments, voice, likeness, municipality of residence and picture in any advertising, promotion or publicity carried out now or in the future, in any media without compensation or notice, and you grant to the Administrator and the Sponsor any and all rights to such use. You agree to cooperate with the Administrator and the Sponsor in arranging for photographs or other forms of publicity and to be available for photographs or other forms of publicity on reasonable notice.",
          ],
        },
        {
          title: "LIMITATION OF LIABILITY / RELEASE",
          para: [
            "By participating in the Contest, and as a condition of acceptance of the Prize, you, your heirs, executors, administrators, successors and assigns, hereby release and forever discharge and hold harmless LoyaltyOne, Co., the Sponsor and the Administrator, and their direct and indirect parent companies, affiliates, subsidiaries, successors, assigns, agents, advisors, franchisees, shareholders, partners, representatives, their advertising, promotion and fulfillment agencies and each of their respective employees, officers, directors, agents and representatives (collectively, the “Released Parties”), from and against any and all losses, damages (including, without limitation, direct, indirect, incidental, consequential or punitive damages), rights, claims, actions, causes of action, personal injury, property damage or death, including without limitation all costs and liabilities of any kind including legal fees on a substantial indemnity scale (hereinafter called “Claims”) and including without limitation any claims arising from any act of negligence of the Released Parties, that you now have, or may hereafter have against the Released Parties directly or indirectly resulting or arising from: (i) participation in the Contest, or the awarding, acceptance, possession, use, or misuse or enjoyment of any Prize, and where applicable, traveling to, preparing for, or participating in, any Contest-related or Prize-related event or activity; or (ii) the publicity rights granted to the Sponsor and the Administrator. You specifically acknowledge that you understand that there may be serious risks of bodily injury, death, or property damage associated with the acceptance, possession, use and/or misuse of the Prize and attendance at any event or participation in certain Prize-related activities, and you voluntarily assumes these risks. You also agree to indemnify, defend, and hold harmless the Released Parties from any and all Claims in respect of the foregoing.",
          ],
        },
        {
          title: "COMPLIANCE WITH RULES",
          para: [
            "By entering the Contest, you agree to abide by the entire Contest Rules and the terms and conditions under which the prizes are awarded. Any decision made by the Sponsor and/or the Administrator in respect of this Contest shall be final.",
          ],
        },
        {
          title: "TECHNICAL ISSUES",
          para: [
            "The Sponsor and Administrator are not responsible for any computer, online, telephone, hardware, software or technical limitations or malfunctions that may occur (including but not limited to malfunctions that may affect the transmission or non-transmission of an entry, or failure to receive an entry), nor for any incorrect or inaccurate information, whether caused by website users or by any of the equipment or programming associated with or utilized in the Contest or by any technical or human error which may occur in the processing of entries in the Contest, nor for any error, omission, interruption, deletion, defect, delay in operation or transmission or receipt of entry, communications line failure, theft or destruction or unauthorized access to, or alteration of entries; and, are not responsible for any problems, failures or technical malfunction of any telephone or network lines, computer online systems, servers, providers, computer equipment, software, email, players, or browsers, on account of technical problems or traffic congestion on the Internet, at any website or on account of any combination of the foregoing; and are not responsible for any injury or damage to entrants or to any computer related injury or damage resulting from participating in downloading materials in this Contest. In no event will the Sponsor or Administrator be liable for more than the stated number of Prizes contained in these Contest Rules.",
          ],
        },
        {
          title: "RIGHTS TO TERMINATE/MODIFY/SUSPEND CONTEST",
          para: [
            "The Administrator and Sponsor retain the right, in their absolute discretion, to suspend, modify or terminate any aspect of the Contest (including, but not limited to these Contest Rules) at any time. The Administrator and Sponsor may make substitutions of equivalent kind or value in the event of the unavailability of the Prize (or component thereof) for any reason whatsoever. The Administrator and Sponsor may terminate or withdraw this Contest at any time by posting a notice on the ShipVista.com app. If the Contest is terminated on any day prior to the normal Contest end date (the “Termination Date”), the Administrator and Sponsor may determine the winner from all eligible entries received as of the close of business on the Termination Date (which winners shall be randomly selected in accordance with these Contest Rules).",
          ],
        },
        {
          title: "DISQUALIFICATION",
          para: [
            "Any attempt made by an entrant or other individual or entity, to deliberately damage, manipulate or undermine the legitimate operation of the Contest, including but not limited to any fraudulent claims, is a violation of the law. The Administrator and Sponsor reserve the right to seek remedies and damages from any such individual or entity which makes any such attempt. Any entrant who, in the opinion of the Administrator, is determined to be engaging in any of the foregoing activities will be immediately disqualified from the Contest. Any entrant who is in breach of the Contest Rules, submits multiple entries, or otherwise engages in misrepresenting their status or acts with the intent of deceiving the Contest Administrators, will be immediately disqualified.",
          ],
        },
        {
          title: "ROLE OF PARTIES",
          para: [
            "LoyaltyOne, Co. is not responsible for the sponsorship or administration of this Contest. ShipVista Corporation. is the Sponsor of this Contest. ShipVista Corporation. is the Administrator of this Contest.",
          ],
        },
        {
          title: "TRADEMARKS",
          para: [
            "®™ Trademarks of AM Royalties Limited Partnership used under license by LoyaltyOne, Co. and ShipVista Corporation. All other Trademarks are the property of their respective owners.",
          ],
        },
        {
          title: "GOVERNING LAW",
          para: [
            "The Contest is governed by the laws of Ontario and the laws of Canada applicable therein and is void where prohibited by law. Participation constitutes your full and unconditional agreement to these Contest Rules and the decisions of the Sponsor and Administrator, which are final and binding in all matters related to the Contest. By entering the Contest, you agree to attorn to the courts of the Province of Ontario sitting in the judicial district of Toronto, which shall have the exclusive jurisdiction to entertain any action or other legal proceeding based on any provision of the Contest’s Rules or the running of this Contest.",
          ],
        },
      ],
    },
  },
};

export const getInstantQuotes = {
  en: {
    chooseServiceTableTitle: "Choose Carrier and Service",
    infoChangedLabel: "The Shipping Info has Changed. Please Get Rates again.",
  },
};

export const newsroomMedia = {
  en: {
    bannerTitle: "ShipVista Press Release & Newsroom",
    bannerImgAlt: "Shipvista Newsroom Banner",
  },
};

export const connectWithUs = {
  en: {
    title: "Connect With Us",
    subTitle1: "Simply fill out the information below and",
    subTitle2: "you will be contacted by one of our product specialist.",
  },
};

export const contactForm = {
  en: {
    name: "Name",
    companyName: "Company Name (optional)",
    email: "Email",
    phone: "Phone",
    businessType: "What type of business do you have?",
    shippingVolume: "What's your monthly shipping volume?",
    helpSubject: "How can we help you?",
    accountNo: "Your Shipvista Account Number (optional)",
    carrierName: "What carriers are you using (or looking to use)?",
    additionalDetails: "Additional Details",
    btnConnect: "Connect With Us",
  },
};

export const common = {
  en: {
    btnGoBack: "Go Back",
    error: "Error",
  },
};

export const jobApply = {
  en: {
    notFound: "Job Not Found",
    openJobs: "Open Jobs",
    applyNow: "Apply Now",
    title1: "Complete The Form Below",
    title2: "Personal Information",
  },
};

// export const  ={
//   en:{}
// }

//content in new format

export const upsCanada = {
  en: {
    hero: {
      title: "Discounted UPS® Shipping Rates on ShipVista",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/logo.svg",
    },
    section1: {
      note: "ShipVista is a certified UPS® vendor partner. Activate your account and start saving on shipments today.",
      title: "About UPS Canada",
      para: "United Parcel Service (UPS) is a global package delivery company that offers a wide range of shipping services for businesses and individuals. When you open a UPS account on ShipVista, you instantly get access to deeply discounted rates and can create domestic and international shipping labels. UPS helps both large and small businesses with their logistical needs. UPS also offers sustainable options such as UPS Paperless™ Invoice.",
    },
    section2: {
      title: "Use your Negotiated Rates with UPS Canada & ShipVista",
      para: "ShipVista is a certified UPS Ready® application that allows you to get rates and create domestic and international shipping labels via your negotiated shipping rates. Simple to Create and Print Discounted UPS® Shipping Labels for Canada-Based Shipments. Save a lot on a few UPS services while having both domestic and international orders fulfilled.",
      btnText: "Start shipping UPS today", //"UPS Ready Program",
    },
    section3: {
      title: "Features of UPS in Canada that ShipVista Supports",
      para: "Your business never slows down. So get your products to your customers faster and easier with UPS® shipping on ShipVista",
      list: [
        {
          title: "Save on shipping services domestically with UPS in Canada:",
          desc: "Get discounts on domestic shipping, including up to 76% off UPS Standard®, 62% off UPS Express Saver® and UPS Expedited®.* ",
        },
        {
          title: "Save on the shipping services for Canada to the U.S.:",
          desc: "Get discounts on shipping, including up to 60% off UPS Standard® to the U.S. and 72% off UPS Express® , UPS Express Saver® and UPS Expedited® to the U.S.*",
        },
        {
          title: "For Canada to Mexico:",
          desc: "Get discounts on shipping, including up to 69% off UPS Express ® to Mexico, and 68% off UPS Express Saver ® and UPS Expedited ® to Mexico.*",
        },
        {
          title:
            "Saturday Delivery- Need something to be delivered on Saturday? Just add Saturday Delivery to your rate!",
          desc: "",
        },
        { title: "", desc: "Global reach of 220+ countries and territories" },
        { title: "Increased weight and size flexibility", desc: "" },
        {
          title:
            "Streamlined customs clearance to facilitate imports and exports",
          desc: "",
        },
      ],
      note: "Note: Rates are limited to shipping from Canada only. Rates and any applicable discounts are subject to change at any time without notice.",
      list2: [
        "Save on Fuel Surcharges",
        "Worldwide UPS tracking",
        "Domestic and international delivery services",
        "No minimum shipping",
      ],
      disclaimer:
        "*Discounts off UPS daily rates. Rates are limited to shipping from Canada only. Rates and any applicable discounts are subject to change at any time without notice. *Inclusive of applicable fuel and residential surcharge. Not including other additional applicable charges and taxes.",
    },
    section4: {
      services: [
        {
          title: "UPS Standard®",
          desc: "Guaranteed day definite service for less urgent shipments",
          link: "/ups-canada/ups-standard",
          details: {
            title1: "UPS Standard®",
            para1:
              "Through this service, you get cost-effective, guaranteed day – definite delivery. UPS Standard®  is the cheapest option for shipping through UPS ground services.",
            features: [
              "Door-to-door delivery",
              "Guaranteed delivery in 2-3 business days",
              "ship packages that weigh 150+ pounds",
              "Guaranteed international shipping for less urgent shipments",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Standard®  Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Standard®  work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Standard®  work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Standard®  shipment?",
                desc: " You can track UPS Standard®  shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Standard®  shipment?",
                desc: "Rates varies based on shipment UPS Standard®  and destination. Sign up today for a free ShipVista account to see the live rates for UPS Standard®  shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Standard®  shipment?",
                desc: "Shipments for UPS Standard®  shipments generally take between 2 - 3 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Standard®  shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Standard®  shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Standard®  shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Standard®  shipment.",
              },
              {
                title: "Do we require a signature on UPS Standard®  delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Express®",
          desc: "Guaranteed next business day delivery by 10:30 a.m.or noon",
          link: "/ups-canada/ups-express",
          details: {
            title1: "UPS Express®",
            para1:
              "UPS Express® is a well-established worldwide express service, high quality service and fast delivery lead time. UPS® Express is the fastest option for shipping from Canada through UPS services.",
            features: [
              "Pricing Calculation - by volumetric weight",
              "Schedule Delivery - Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Stand-Alone Batteries are not allowed",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS® Express Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Express® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Express® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Express® shipment?",
                desc: " You can track UPS Express® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title: "What are the shipping rates for UPS Express® shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for UPS Express® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Express® shipment to United States?",
                desc: "Shipments for UPS Express® shipments varies origin to destination accordingly. Sign up for an ShipVista account to see the most accurate delivery time for UPS Express® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Express® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Express® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Express® shipment.",
              },
              {
                title: "Do we require a signature on UPS Express® delivery?",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Express® Early",
          desc: "Guaranteed delivery the next business day by 9:00 a.m.",
          link: "/ups-canada/ups-express-early",
          details: {
            title1: "UPS Express® Early",
            para1:
              "UPS Express® Early is a well-established express service, high quality service and fast delivery lead time. UPS Express® Early is guaranteed delivery the next business day by 9:00 a.m.",
            features: [
              "Pricing Calculation - by volumetric weight",
              "Schedule Delivery - Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Stand-Alone Batteries are not allowed",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Express® Early Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Express® Early work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Express® Early work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Express® Early shipment?",
                desc: " You can track UPS Express® Early shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Express® Early shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for UPS Express® Early shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Express® Early shipment to United States?",
                desc: "Shipments for UPS Express® Early shipments varies origin to destination accordingly. Sign up for an ShipVista account to see the most accurate delivery time for UPS Express® Early shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Express® Early shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Express® Early shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Express® Early shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Express® Early delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Express Saver®",
          desc: "Guaranteed next business day delivery by 3:00 p.m.",
          link: "/ups-canada/ups-express-saver",
          details: {
            title1: "UPS Express Saver®",
            para1:
              "UPS Express Saver® provides a fully tracked service that will swiftly deliver your product and guarantee a low cost of delivery.",
            features: [
              "Pricing Calculation - by volumetric weight",
              "Schedule Delivery - Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Stand-Alone Batteries are not allowed",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Express Saver® Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Express Saver®  work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Express Saver®  work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Express Saver® shipment?",
                desc: " You can track UPS Express Saver®  shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Express Saver®  shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for UPS Express Saver®  shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Express Saver®  shipment to United States?",
                desc: "Shipments for  UPS Express Saver® are guaranteed next business day delivery by 3:00 p.m.. Sign up for an ShipVista account to see the most accurate delivery time for   UPS Express Saver®  shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Express Saver®  shipment?",
                desc: "There aren't many limitations on what you can ship with   UPS Express Saver®  shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using   UPS Express Saver®  shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Express Saver®  delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Expedited®",
          desc: "Guaranteed delivery by the second business day",
          link: "/ups-canada/ups-expedited",
          details: {
            title1: "UPS Expedited®",
            para1:
              "UPS Expedited® offers customs-cleared, day-definite delivery to more than 220 countries and territories in two to five business days.",
            features: [
              "Up to three delivery attempts",
              "Pricing Calculation - by volumetric weight",
              "Schedule Delivery - Offered",
              "Powerful package tracking",
              "Notification services",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Expedited® Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Expedited® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Expedited® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Expedited® shipment?",
                desc: " You can track UPS Expedited® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Expedited® shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for UPS Expedited® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Expedited® shipment to United States?",
                desc: "Shipments for UPS Expedited® shipments varies origin to destination accordingly. Sign up for an ShipVista account to see the most accurate delivery time for UPS Expedited® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Expedited® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Expedited® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Expedited® shipment.",
              },
              {
                title: "Do we require a signature on UPS Expedited® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Express™",
          desc: "UPS Worldwide Express® shipping service is one of the faster international shipping options that UPS provides. On average, deliveries using this service take 1-3 business days to reach their destination.",
          link: "/ups-canada/ups-worldwide-express",
          details: {
            title1: "UPS Worldwide Express™",
            para1:
              "Through this service, you get delivery to more than 220 countries and territories within 1-3 business days. Tracking is available.",
            features: [
              "Same day pickup and delivery to the clients",
              "Pricing - Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - Both Sender and Receiver Can Pay The Taxes",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Prohibited Items - See UPS website for full list of restricted items.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Worldwide Express® Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Worldwide Express® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Worldwide Express® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Worldwide Express® shipment?",
                desc: " You can track UPS Worldwide Express® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Worldwide Express® shipment?",
                desc: "Rates varies based on shipment UPS Worldwide Express® and destination. Sign up today for a free ShipVista account to see the live rates for UPS Worldwide Express® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Worldwide Express® shipment?",
                desc: "Shipments for UPS Worldwide Saver® shipments generally take between 2 - 5 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Worldwide Express® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Worldwide Express® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Worldwide Express® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Worldwide Express® shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Worldwide Express® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Express Plus™",
          desc: "Parcels shipped with UPS Worldwide Express Plus® service typically take 2-3 business days in transit to arrive to customers.",
          link: "/ups-canada/ups-worldwide-express-plus",
          details: {
            title1: "UPS Worldwide Express Plus™",
            para1:
              "Through this service, you get Worldwide Express shipments that need to arrive to their destination earlier in the morning.",
            features: [
              "Same day pickup and delivery to the clients",
              "Pricing - Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - Both Sender and Receiver Can Pay The Taxes",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Prohibited Items - See UPS website for full list of restricted items.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Worldwide Express plus® Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Worldwide Express plus® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Worldwide Express plus® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Worldwide Express plus® shipment?",
                desc: " You can track UPS Worldwide Express plus® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Worldwide Express plus® shipment?",
                desc: "Rates varies based on shipment UPS Worldwide Express plus® and destination. Sign up today for a free ShipVista account to see the live rates for UPS Worldwide Express plus® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Worldwide Express plus® shipment?",
                desc: "Shipments for UPS Worldwide Saver® shipments generally take between 2 - 5 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Worldwide Express plus® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title:
                  "What can I ship with UPS Worldwide Express plus® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Worldwide Express plus® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Worldwide Express plus® shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Worldwide Express plus® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Express Saver®",
          desc: "Delivery in two to three business days by the end of the day to most countries in the world.",
          link: "/ups-canada/ups-worldwide-express-saver",
          details: {
            title1: "UPS Worldwide Express Saver®",
            para1: " Guaranteed delivery by end of day",
            features: [
              "Delivery by the end of the second business day to the United States and Canada",
              "Delivery in two to three business days by the end of the day to most countries in the world",
              "Day-definite delivery by the end of the business day to other countries, depending on destination",
              "Import: Day-definite delivery by the end of the business day from origin countries worldwide",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Worldwide Express Saver® Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "By visiting the UPS website and utilizing the provided tracking number, you can follow UPS® packages.",
              },
            ],
          },
        },
        {
          title: "UPS 3 Day Select® to the U.S.",
          desc: "Delivery between 3 - 3 days",
          link: "/ups-canada/ups-3-day-select-to-the-us",
          details: {
            title1: "UPS 3 Day Select® to the U.S.",
            para1:
              "Businesses can send packages anywhere in the 48 contiguous states with confidence that it will arrive by the third business day. Deliveries arrive the third business day. Package size limits: Up to 150 lbs. and up to 108” long.",
            features: [
              "Deliveries arrive the third business day.",
              "Package size limits: Up to 150 lbs. and up to 108” long.",
              "Available in all the 48 contiguous states.",
              "Saturday pickup and delivery available in select areas.",
              "Online pickup scheduling and package tracking services.",
              "Free liability coverage up to $100.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS 3 Day Select® to the U.S. Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "By visiting the UPS website and utilizing the provided tracking number, you can follow UPS® packages.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Expedited™",
          desc: "Delivery between 3 - 3 days",
          link: "/ups-canada/ups-worldwide-expedited",
          details: {
            title1: "UPS Worldwide Expedited™",
            para1:
              "UPS Worldwide Expedited offers customs-cleared, day-definite delivery to more than 220 countries and territories in two to five business days. When deadlines are more flexible, this best-in-class global service can help you balance speed with cost. Get your shipments where they need to be without hurting your budget.",
            features: [
              "Delivery in two business days to Canada",
              "Next business day delivery to Canada and for documents to Mexico",
              "Delivery in three or four days to Europe",
              "Delivery in four or five days to Asia and Latin America UPS Standard",
              "Day-definite delivery based on origin and destination",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Worldwide Expedited™ Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "By visiting the UPS website and utilizing the provided tracking number, you can follow UPS® packages.",
              },
            ],
          },
        },
        {
          title: "UPS Standard® to the U.S.",
          desc: "Day-definite delivery in one to five days. UPS Standard is an economical choice for all your routine shipments.",
          link: "/ups-canada/ups-standard-to-the-us",
          details: {
            title1: "UPS Standard® to the U.S.",
            para1:
              "UPS Worldwide Expedited offers customs-cleared, day-definite delivery to more than 220 countries and territories in two to five business days. When deadlines are more flexible, this best-in-class global service can help you balance speed with cost. Get your shipments where they need to be without hurting your budget.",
            features: [
              "UPS® Standard gives you cost-effective, guaranteed day – definite delivery. You also get free tracking information for your shipment, 24/7.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Standard® to the U.S. Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "By visiting the UPS website and utilizing the provided tracking number, you can follow UPS® packages.",
              },
            ],
          },
        },
        {
          title: "UPS Express Early® to the U.S.",
          desc: "UPS Express® Early will get your product there next day as early as 8.00 a.m. ",
          link: "/ups-canada/ups-express-early-to-the-us",
          details: {
            title1: "UPS Express Early® to the U.S.",
            para1:
              "UPS Express® Early gives you guaranteed early morning delivery for time-critical shipments.",
            features: [
              "UPS® Express® Early gives guaranteed early morning delivery for time-critical shipments. Guaranteed delivery by 8 a.m. to major cities and by 8:30 a.m., 9 a.m. or 9:30 a.m. to most cities, with Saturday delivery to some locations as early as 9 a.m.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Express Early® to the U.S. Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "By visiting the UPS website and utilizing the provided tracking number, you can follow UPS® packages.",
              },
            ],
          },
        },
      ],
      title: "UPS in Canada Services",
      para: "UPS offers the following services on the ShipVista platform to ship both domestically in Canada and internationally.",
    },
    section5: {
      faqs: [
        {
          title: "Can I integrate my UPS® account to ShipVista?",
          desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
        },
        {
          title: "How can I contact UPS®?",
          desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
        },
        {
          title: "How do I find my UPS® tracking number?",
          desc: "You can find tracking number for the UPS® shipment provided in shipment History the ShipVista website.",
        },
        {
          title: "Does UPS require a signature on delivery?",
          desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of label creation whether or not a signature on delivery will be necessary for release.",
        },
      ],
      title: "Frequently Asked Questions",
      para: "More on shipping with UPS - Common questions about UPS. UPS’s rates include Fuel Surcharge in the rate in Canada, and that’s good news for you! This will make your shipping expenses more constant and means you have more control!",
    },
    section6: {
      title: "Integrate UPS Canada Account on ShipVista",
      integration: {
        requirements: [
          "An active account with UPS.",
          "Your UPS account billing address, phone number, and email address..",
        ],
        connect: [
          {
            list: "Ensure that you are logged into the app and can see the main dashboard.",
          },
          {
            list: "Click the setting icon at the top right hand corner of the window to go to the settings pages.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/settings-cog.png",
          },
          {
            list: "Click the 'Integrations' button on the left hand side accordian to expand the integrations panel.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/click-intergrations.png",
          },
          {
            list: "Select the 'Carrier Setup' option in the panel that opens.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/select-carrier-setup.png",
          },
          {
            list: "Click the 'Connect Carrier Account' button near the top right hand corner of the screen.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/carrier-connect-button.png",
          },
          {
            list: "In the dialog that opens, select the UPS logo and a form should open.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups/carrier-list.png",
          },
          {
            list: "In the form, enter the correct information and proceed by clicking the 'Connect Account' button at the bottom of the form.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups/ups-connect.png",
          },
        ],
        features: [
          {
            name: "Domestic Shipping",
            status: "Yes",
          },
          {
            name: "International Shipping",
            status: "Yes",
          },
          {
            name: "Electronic Customs Submission",
            status: "Yes",
          },
          {
            name: "Return Labels",
            status: "Yes",
          },
          {
            name: "Estimated Rates",
            status: "Yes",
          },
          {
            name: "Carrier Insurance",
            status: "Yes",
          },
          {
            name: "Tracking",
            status: "Yes",
          },
          {
            name: "Automatic Tracking",
            status: "Yes",
          },
          {
            name: "End of Day (Electronic)",
            status: "Yes",
          },
          {
            name: "End of Day (PDF)",
            status: "Yes",
          },
          {
            name: "Label Branding",
            status: "Yes",
          },
          {
            name: "Label Messages",
            status: "Yes",
          },
          {
            name: "Multi-package Shipping",
            status: "Yes",
          },
          {
            name: "Multiple Accounts",
            status: "Yes",
          },
        ],
        additionalDetails:
          "It is advisable to import orders through ShipVista only.",
        troubleshooting:
          "Please contact our customer care team if any issues arise. Visit the support page for contact details.",
      },
    },
  },
};

export const upsUS = {
  en: {
    hero: {
      title: "Discounted U.S. UPS® Shipping Rates on ShipVista",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/ups/logo.svg",
    },
    section1: {
      note: "ShipVista is a certified UPS® vendor partner. Activate your account and start saving on shipments today.",
      title: "About UPS",
      para: "UPS (United Parcel Service) is a global logistics company and one of the world's largest shipping couriers that provides a variety of shipping services.UPS helps both large and small businesses with their logistical needs. UPS offers sustainability options like paperless invoices and their Carbon Neutral program.",
    },
    section2: {
      title: "Use your Negotiated Rates with UPS & ShipVista",
      para: "ShipVista is a certified UPS Ready® application that allows you to get rates and create domestic and international shipping labels via your negotiated UPS shipping rates.",
      btnText: "Start shipping UPS today", //"UPS Ready Program",
    },
    section3: {
      title: "Features of UPS that ShipVista Supports",
      para: "ShipVista is a certified UPS Ready® application and ShipVista users will enjoy seamless connectivity to UPS® shipping services with competitive discounts and more benefits:",
      list: [
        {
          title: "Negotiated Rates for UPS USA(Domestic and International)",
          desc: "",
        },
        {
          title:
            "Saturday Delivery- Need something to be delivered on Saturday? Just add Saturday Delivery to your rate!",
          desc: "",
        },
        {
          title: "",
          desc: "Global reach of 220+ countries and territories",
        },
        {
          title: "Increased weight and size flexibility",
          desc: "",
        },
        {
          title:
            "Streamlined customs clearance to facilitate imports and exports",
          desc: "",
        },
      ],
      note: "",
      list2: [
        "Save on Fuel Surcharges",
        "Worldwide UPS tracking",
        "Domestic and international delivery services",
        "No minimum shipping",
      ],
      disclaimer:
        "*Disclaimer: Discounts off UPS daily rates. Rates are limited to shipping from the U.S. only. Rates and any applicable discounts are subject to change at any time without notice.",
    },
    section4: {
      services: [
        {
          title: "UPS Worldwide Saver®",
          desc: "Delivery in 1-3 business days, by end-of-day. Save up to 75% off Daily Rates.",
          link: "/ups-usa/ups-worldwide-saver",
          details: {
            title1: "",
            para1:
              " Guaranteed delivery to more than 220 countries and territories before the end of the business day. Delivery is assured to occur the next business day to Canada, the second business day to Europe and Latin America, for papers to Mexico, and within two to three business days to Asia. Prices include normal, in-house customs clearance by UPS Supply Chain Solutions as well  as door-to-door delivery.",
            features: [
              "Cost-effective option for international shipping",
              "Handover Type - Offers free pickup, Allows drop off",
              "Pricing Calculation - By volumetric weight",
              "Schedule Delivery - Offered",
              "Maximum Measurements - Length: 108 in, Weight: 150 lbs, Volume: 165 in",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Worldwide Saver® Rates with ShipVista",
            faqs: [
              {
                title: "How does UPS Worldwide Saver® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Worldwide Saver®. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "What are the shipping rates for UPS Worldwide Saver®?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for UPS Worldwide Saver® and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Worldwide Saver® shipment?",
                desc: "Shipments for UPS Worldwide Saver® shipments generally take between 2 - 5 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Worldwide Saver®.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Worldwide Saver®?",
                desc: "Although there aren't many restrictions on what you may mail with UPS Worldwide Saver®, you should be aware that most places normally don't allow you to transport goods like food, wine, and other items. See the UPS website for a complete list of prohibited products while using UPS Worldwide Saver®.",
              },
              {
                title: "Do we require a signature on UPS delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Next Day Air Saver®",
          desc: "Delivery by 3:00 P.M. or 4:30 P.M. to most commercial destinations.",
          link: "/ups-usa/ups-next-day-air-saver",
          details: {
            title1: "UPS Next Day Air Saver®",
            para1:
              "Through this service, you get the cost-effective option for when you need the extra security that tracking offers.",
            features: [
              "Budget-friendly solution - with tracking",
              "Pricing - Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - Yes, Before it is delivered",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Next Day Air Saver® Rates with ShipVista",
            faqs: [
              {
                title: "How does UPS Next Day Air Saver® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Next Day Air Saver® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Next Day Air Saver® shipment?",
                desc: " You can track UPS Next Day Air Saver® shipments using the tracking number for the shipment provided and visiting the ShipVista website in shipment History",
              },
              {
                title:
                  "What are the shipping rates for UPS Next Day Air Saver® shipment?",
                desc: "Rates varies based on shipment UPS Next Day Air Saver® and destination. Sign up today for a free ShipVista account to see the live rates for UPS Next Day Air Saver® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Next Day Air Saver® shipment?",
                desc: "Shipments for UPS Next Day Air Saver® shipments generally take between 2 - 2 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Next Day Air Saver® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Next Day Air Saver® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Next Day Air Saver® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS® Next Day Air Saver® shipment.",
              },
              {
                title:
                  "Do we require a signature on Next Day Air Saver® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS 3 Day Select®",
          desc: "Delivery in 1-3 business days, by end-of-day. Save up to 64% off Daily Rates.",
          link: "/ups-usa/ups-3-day-select",
          details: {
            title1: "UPS 3 Day Select®",
            para1:
              "Well-established worldwide express service for documents. UPS 3 Day Select® guarantees delivery within 3 business days to the 48 contiguous states within the United States. Tracking is available.",
            features: [
              "Delivery within 3 business days",
              "Pricing - Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - You can recall a shipment before it is delivered",
              "Import Tax Handling - No Import Tax",
              "Schedule Delivery is Not offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Saturday delivery is available for UPS 3 Day Select ",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS 3 Day Select® Rates with ShipVista",
            faqs: [
              {
                title: "How does UPS 3 Day Select® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS 3 Day Select®. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "What are the shipping rates for UPS 3 Day Select®?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for UPS UPS 3 Day Select® and other services we offer.",
              },
              {
                title: "How long will delivery take for a UPS 3 Day Select®?",
                desc: "Shipments for UPS 3 Day Select® shipments generally take between 3 - 3 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS 3 Day Select®.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS 3 Day Select®?",
                desc: "There aren't many limitations on what you can ship with UPS 3 Day Select®, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS 3 Day Select®.",
              },
              {
                title: "Do we require a signature on UPS delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Next Day Air®",
          desc: " UPS Next Day Air®. Save up to 72% off Daily Rates.",
          link: "/ups-usa/ups-next-day-air",
          details: {
            title1: "UPS Next Day Air®",
            para1:
              "Your business can transport packages abroad swiftly, easily, and safely with the Standard service. We promise absolute dependability for your shipments owing to a network of international partners. This service guarantees delivery the next business day from all 50 U.S. states to the 48 contiguous states within the United States. This service is useful for urgent shipments.",
            features: [
              "Delivery Next day",
              "Pricing - Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Next Day Air® Rates with ShipVista",
            faqs: [
              {
                title: "How does  UPS Next Day Air® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with  UPS Next Day Air® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Next Day Air® shipment?",
                desc: " You can track UPS Next Day Air® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Next Day Air® shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Next Day Air® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Next Day Air® shipment?",
                desc: "Shipments for UPS Next Day Air® shipments generally take between 1 - 1 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Next Day Air® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Next Day Air® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Next Day Air® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Next Day Air® shipment.",
              },
              {
                title: "Do we require a signature on UPS delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS 2nd Day Air®",
          desc: "Second Day Air® Delivery. Save up to 72% off Daily Rates.",
          link: "/ups-usa/ups-2-day-air",
          details: {
            title1: "UPS 2nd Day Air®",
            para1:
              "UPS 2nd Day Air® is fast and guaranteed international service for less urgent shipments. UPS 2nd Day Air®  offers delivery within 2 business days to all 50 states and Puerto Rico with some limitations in Alaska and Hawaii.  Tracking is available.",
            features: [
              "Delivery within 2 business days",
              "Pricing - Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - You can recall a shipment before it is delivered",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Saturday delivery is available for UPS 2nd Day Air ",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS 2nd Day Air® Rates with ShipVista",
            faqs: [
              {
                title: "How does  UPS 2nd Day Air® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with  UPS 2nd Day Air® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS 2nd Day Air® shipment?",
                desc: " You can track UPS 2nd Day Air® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS 2nd Day Air® shipment?",
                desc: "Rates varies based on shipment UPS 2nd Day Air® and destination. Sign up today for a free ShipVista account to see the live rates for UPS 2nd Day Air® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS 2nd Day Air® shipment?",
                desc: "Shipments for UPS 2nd Day Air® shipments generally take between 2 - 2 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS 2nd Day Air® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS 2nd Day Air® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS 2nd Day Air® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS 2nd Day Air® shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS 2nd Day Air® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Expedited®",
          desc: "Delivery in 2-5 business days, by end-of-day. Save up to 76% off Daily Rates.",
          link: "/ups-usa/ups-worldwide-expedited",
          details: {
            title1: "UPS Worldwide Expedited®",
            para1:
              " Through this service, you get cost-effective, delivery to more than 220 countries and territories within 2-5 business days. It is an economical option for international shipping. Tracking is available.",
            features: [
              "Only Accept unused equipment contains lithium battery",
              "Irregular packing is not accepted",
              "Pricing - Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Worldwide Expedited® Rates with ShipVista",
            faqs: [
              {
                title: "How does  UPS Worldwide Expedited® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with  UPS Worldwide Expedited® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Worldwide Expedited® shipment?",
                desc: " You can track UPS Worldwide Expedited® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Worldwide Expedited® shipment?",
                desc: "Rates varies based on shipment UPS Worldwide Expedited® and destination. Sign up today for a free ShipVista account to see the live rates for UPS Worldwide Expedited® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Worldwide Expedited® shipment?",
                desc: "Shipments for UPS Worldwide Expedited® shipments generally take between 2 - 2 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Worldwide Expedited® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title:
                  "What can I ship with UPS Worldwide Expedited® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Worldwide Expedited® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS® Worldwide Expedited® shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Worldwide Expedited® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Express®",
          desc: "Delivery in 1-3 business days, by 10:30 AM or noon. Save up to 74% off Daily Rates.",
          link: "/ups-usa/ups-worldwide-express",
          details: {
            title1: "UPS Worldwide Express™",
            para1:
              "Through this service, you get delivery to more than 220 countries and territories within 1-3 business days. Tracking is available.",
            features: [
              "Same day pickup and delivery to the clients",
              "Pricing - Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - Both Sender and Receiver Can Pay The Taxes",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Prohibited Items - See UPS website for full list of restricted items.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS Worldwide Express® Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Worldwide Express® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Worldwide Express® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Worldwide Express® shipment?",
                desc: " You can track UPS Worldwide Express® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Worldwide Express® shipment?",
                desc: "Rates varies based on shipment UPS Worldwide Express® and destination. Sign up today for a free ShipVista account to see the live rates for UPS Worldwide Express® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Worldwide Express® shipment?",
                desc: "Shipments for UPS Worldwide Saver® shipments generally take between 2 - 5 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Worldwide Express® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS Worldwide Express® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Worldwide Express® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Worldwide Express® shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Worldwide Express® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS® Standard to Canada",
          desc: "Delivery in 3-7 business days, by end-of-day. Save up to 58% off Daily Rates.",
          link: "/ups-usa/ups-standard-to-canada",
          details: {
            title1: "UPS® Standard to Canada",
            para1:
              "Through this service, you get a great option when economy and speed need to coexist. You can schedule deliveries using day-specific delivery estimates. Door-to-door service that is convenient.",
            features: [
              "Door to Door Service",
              "Pricing - Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - Both Sender and Receiver Can Pay The Taxes",
              "Schedule Delivery is not offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Prohibited Items - See UPS website for full list of restricted items",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS® Standard to Canada Rates with ShipVista",
            faqs: [
              {
                title: "How does  UPS® Standard to Canada work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with  UPS® Standard to Canada work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS® Standard to Canada shipment?",
                desc: " You can track UPS® Standard to Canada shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS® Standard to Canada shipment?",
                desc: "Rates varies based on shipment UPS® Standard to Canada and destination. Sign up today for a free ShipVista account to see the live rates for UPS® Standard to Canada shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS® Standard to Canada shipment?",
                desc: "Delivery time varies on origin and destination. Sign up for an ShipVista account to see the most accurate delivery time for UPS® Standard to Canada shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title: "What can I ship with UPS® Standard to Canada shipment?",
                desc: "There aren't many limitations on what you can ship with UPS® Standard to Canada shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS® Standard to Canada shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS® Standard to Canada delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Worldwide Express Plus®",
          desc: "1-3 business days, typically by 8:30 or 9:00 a.m.",
          link: "/ups-usa/ups-worldwide-express-plus",
          details: {
            title1: "UPS Worldwide Express Plus™",
            para1:
              "Through this service, you get Worldwide Express shipments that need to arrive to their destination earlier in the morning.",
            features: [
              "Same day pickup and delivery to the clients",
              "Pricing - Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - By volumetric weight",
              "Recall Policy - No",
              "Handover Type - Offers paid pickup, Allows drop off",
              "Import Tax Handling - Both Sender and Receiver Can Pay The Taxes",
              "Schedule Delivery is offered",
              "Maximum Measurements -Length: 108 in, Weight: 150 lbs, Volume: 165 in",
              "Prohibited Items - See UPS website for full list of restricted items.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Worldwide Express plus® Rates with ShipVista",
            faqPara2:
              "Being one of the biggest package delivery firms in the world, UPS® - United Parcel Service, offers clients in more than 220 countries and territories a wide range of integrated logistics solutions.",
            faqs: [
              {
                title: "How does UPS Worldwide Express plus® work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with UPS Worldwide Express plus® work. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact UPS for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact UPS directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a UPS Worldwide Express plus® shipment?",
                desc: " You can track UPS Worldwide Express plus® shipments using the tracking number for the shipment provided and visiting the UPS website.",
              },
              {
                title:
                  "What are the shipping rates for UPS Worldwide Express plus® shipment?",
                desc: "Rates varies based on shipment UPS Worldwide Express plus® and destination. Sign up today for a free ShipVista account to see the live rates for UPS Worldwide Express plus® shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a UPS Worldwide Express plus® shipment?",
                desc: "Shipments for UPS Worldwide Saver® shipments generally take between 2 - 5 days depending upon countries. Sign up for an ShipVista account to see the most accurate delivery time for UPS Worldwide Express plus® shipment.",
              },
              {
                title: "Where can I find a UPS location nearby?",
                desc: "UPS has an industry-leading global network of more than 78,000 locations to pick up or drop off. You can find the nearest location to you here.",
              },
              {
                title:
                  "What can I ship with UPS Worldwide Express plus® shipment?",
                desc: "There aren't many limitations on what you can ship with UPS Worldwide Express plus® shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. See the UPS website for a complete list of prohibited products while using UPS Worldwide Express plus® shipment.",
              },
              {
                title:
                  "Do we require a signature on UPS Worldwide Express plus® delivery??",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS Next Day Air® Early™",
          desc: "Guaranteed delivery by 8 a.m. to major cities and by 8:30 a.m., 9 a.m. or 9:30 a.m. to most cities, with Saturday delivery to some locations as early as 9 a.m.",
          link: "/ups-usa/ups-next-day-air-early",
          details: {
            title1: "UPS Next Day Air® Early™",
            para1:
              "UPS Next Day Air® Early gives you guaranteed early morning delivery for time-critical shipments. Guaranteed delivery by 8 a.m. to major cities and by 8:30 a.m., 9 a.m. or 9:30 a.m. to most cities, with Saturday delivery to some locations as early as 9 a.m.",
            features: [
              "Recommended for shipments that must arrive at the start of the next business day",
              "Guaranteed delivery by 8 a.m. to major cities and by 8:30 a.m., 9 a.m. or 9:30 a.m. to most cities, with Saturday delivery to some locations as early as 9 a.m.",
              "Available to major cities in the 48 contiguous states, plus select cities in Alaska and Hawaii",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText:
              "Access UPS Next Day Air® Early™ Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "You can find tracking number for the UPS® shipment provided in shipment History the ShipVista website.",
              },
              {
                title: "Does UPS require a signature on delivery?",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of label creation whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS® Ground",
          desc: "Transit times are between one to five business days, with Saturday delivery standard to most residential addresses.",
          link: "/ups-usa/ups-ground",
          details: {
            title1: "UPS® Ground",
            para1:
              "UPS Ground gives you cost-effective, day definite delivery within one to five business days, with more on-time deliveries than FedEx.",
            features: [
              "UPS Ground delivers to businesses and homes in all 50 states and Puerto Rico.",
              "Packages can be up to 150 lbs. and up to 108” long.",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access UPS® Ground Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "You can find tracking number for the UPS® shipment provided in shipment History the ShipVista website.",
              },
              {
                title: "Does UPS require a signature on delivery?",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of label creation whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "UPS® Standard to Mexico",
          desc: "UPS Standard packages to anywhere within Mexico within 3 to 7 business days.",
          link: "/ups-usa/ups-standard-to-mexico",
          details: {
            title1: "UPS® Standard to Mexico",
            para1:
              "UPS Standard offers affordable rates for shipments going to Mexico that don't need the fastest delivery.",
            features: [
              "Cover the entire country and can provide supply chain solutions to all of Mexico’s diverse markets",
              "390+ locations and over 550 vehicles and are the only carrier with guaranteed ground service there",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups-assets/package-delivery-bg.jpg",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access  Rates with ShipVista",
            faqs: [
              {
                title: "Can I integrate my UPS® account to ShipVista?",
                desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
              },
              {
                title: "How can I contact UPS®?",
                desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
              },
              {
                title: "How do I find my UPS® tracking number?",
                desc: "You can find tracking number for the UPS® shipment provided in shipment History the ShipVista website.",
              },
              {
                title: "Does UPS require a signature on delivery?",
                desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of label creation whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
      ],
      title: "Supported UPS Shipping Services",
      para: "UPS offers the following services on the ShipVista platform to ship both domestically and internationally.",
    },
    section5: {
      faqs: [
        {
          title: "Can I integrate my UPS® account to ShipVista?",
          desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your UPS® account. It only takes a few minutes to link your UPS® account. For information, visit our help centre.",
        },
        {
          title: "How can I contact UPS®?",
          desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with UPS® directly while shipping with ShipVista. You can visit the UPS website at https://www.ups.com to learn more.",
        },
        {
          title: "How do I find my UPS® tracking number?",
          desc: "You can find tracking number for the UPS® shipment provided in shipment History the ShipVista website.",
        },
        {
          title: "Does UPS require a signature on delivery?",
          desc: "An optional signature-on-delivery service is provided by UPS. The sender will select at the time of label creation whether or not a signature on delivery will be necessary for release.",
        },
      ],
      title: "Frequently Asked Questions",
      para: "More on shipping with UPS - Common questions about UPS.",
    },
    section6: {
      title: "Integrate UPS Account on ShipVista",
      integration: {
        requirements: [
          "An active account with UPS.",
          "Your UPS account billing address, phone number, and email address..",
        ],
        connect: [
          {
            list: "Ensure that you are logged into the app and can see the main dashboard.",
          },
          {
            list: "Click the setting icon at the top right hand corner of the window to go to the settings pages.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/settings-cog.png",
          },
          {
            list: "Click the 'Integrations' button on the left hand side accordian to expand the integrations panel.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/click-intergrations.png",
          },
          {
            list: "Select the 'Carrier Setup' option in the panel that opens.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/select-carrier-setup.png",
          },
          {
            list: "Click the 'Connect Carrier Account' button near the top right hand corner of the screen.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/carrier-connect-button.png",
          },
          {
            list: "In the dialog that opens, select the UPS logo and a form should open.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups/carrier-list.png",
          },
          {
            list: "In the form, enter the correct information and proceed by clicking the 'Connect Account' button at the bottom of the form.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/ups/ups-connect.png",
          },
        ],
        features: [
          {
            name: "Domestic Shipping",
            status: "Yes",
          },
          {
            name: "International Shipping",
            status: "Yes",
          },
          {
            name: "Electronic Customs Submission",
            status: "Yes",
          },
          {
            name: "Return Labels",
            status: "Yes",
          },
          {
            name: "Estimated Rates",
            status: "Yes",
          },
          {
            name: "Carrier Insurance",
            status: "Yes",
          },
          {
            name: "Tracking",
            status: "Yes",
          },
          {
            name: "Automatic Tracking",
            status: "Yes",
          },
          {
            name: "End of Day (Electronic)",
            status: "Yes",
          },
          {
            name: "End of Day (PDF)",
            status: "Yes",
          },
          {
            name: "Label Branding",
            status: "Yes",
          },
          {
            name: "Label Messages",
            status: "Yes",
          },
          {
            name: "Multi-package Shipping",
            status: "Yes",
          },
          {
            name: "Multiple Accounts",
            status: "Yes",
          },
        ],
        additionalDetails:
          "It is advisable to import orders through ShipVista only.",
        troubleshooting:
          "Please contact our customer care team if any issues arise. Visit the support page for contact details.",
      },
    },
  },
};

export const canadaPost = {
  en: {
    hero: {
      title:
        "ShipVista is a certified Canada Post partner. Activate your account and start saving on shipments today.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/canada-post/canada-post.png",
    },
    section1: {
      note: "ShipVista is a certified Canada Post partner. Activate your account and start saving on shipments today.",
      title: "About Canada Post",
      para: "Canada Post is the no. 1 courier service in Canada, and a Crown corporation.ShipVista is a dedicated Canada Post partner! We allow users to get rates and to create both domestic and international shipping labels for Canada Post shipments. Use ShipVista with either a Canada Post Commercial or SFSB (Solutions for Small Business) account and you can create manifests for your outbound shipments.",
    },
    section2: {
      title: "The Best Canada Post rates only on ShipVista",
      para: "Utilize ShipVista to power your label creation, courier comparison, and shipping automation's for both domestic and international shipments and get the lowest Canada Post costs available. With ShipVista, you can ship with Canada Post and save time and money.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
    },
    section3: {
      title: "Features of Canada Post that ShipVista supports",
      para: "Canada Post is Postal service operated by the Canadian government which offers the various services through the ShipVista platform to ship within Canada.",
      list: [
        {
          title: "Automate repetitive tasks with ShipVista",
          desc: "",
        },
        {
          title:
            "Expand your business using ShipVista global fulfillment network",
          desc: "",
        },
        {
          title: "Sync orders directly from your store",
          desc: "",
        },
        {
          title: "Full Clarity on import tax & duties",
          desc: "",
        },
        {
          title: "Best-in-class shipping solution",
          desc: "",
        },
        {
          title:
            "All backed by excellent customer support and unique ticketing system",
          desc: "",
        },
      ],
      note: "",
      list2: [
        "Paperless Billing",
        "Multiple Services",
        "Real-Time Tracking",
        "Electronic Proof of Delivery",
      ],
      disclaimer: "",
    },
    section4: {
      services: [
        {
          title: "Canada Post Xpresspost",
          desc: "A cost effective ground shipping solution within Canada",
          link: "/canada-post/canada-post-xpresspost",
          details: {
            title1: "Canada Post Xpresspost",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Offered",
              "Handover Type - No pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts - Up to Three Attempts",
              "Height: 199 cm, Weight: 30 kg, Volume: 299 cm",
              "Prohibited Items : No battery",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Xpresspost for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Xpresspost directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canada Post Xpresspost shipment?",
                desc: "You can track Canada Post Xpresspost shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Xpresspost shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Xpresspost shipment and other services we offer.",
              },
              {
                title: "What can I ship with Canada Post Xpresspost shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Xpresspost shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Xpresspost, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Xpresspost delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Xpresspost. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Domestic Expedited Parcel",
          desc: "For Cost-effective Shipping within Canada",
          link: "/canada-post/canada-post-domestic-expedited-parcel",
          details: {
            title1: "Canada Post Domestic Expedited Parcel",
            para1:
              "This trackable service has many pick-up and drop-off points are available. Excellent bargain for shipments inside of France.",
            features: [
              "Pricing Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Offered",
              "Handover Type - No pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts - Depends on Local Service",
              "Height: 20, Length: 38, Width: 27, Weight: 30 kg, Volume: 300",
              "Prohibited Items : Stand-Alone Batteries",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Domestic Expedited Parcel work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Domestic Expedited Parcel. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Domestic Expedited Parcel for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Domestic Expedited Parcel directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title:
                  "How do I track a Canada Post Domestic Expedited Parcel shipment?",
                desc: " You can track Canada Post Domestic Expedited Parcel shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Domestic Expedited Parcel shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Domestic Expedited Parcel shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Domestic Expedited Parcel shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Domestic Expedited Parcel shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Domestic Expedited Parcel, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Domestic Expedited Parcel delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Domestic Expedited Parcel. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Xpresspost USA",
          desc: "A cost effective ground shipping solution to USA",
          link: "/canada-post/canada-post-xpresspost-usa",
          details: {
            title1: "Canada Post Xpresspost USA",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Courier Insurance is not offered by Canada Post Xpresspost USA *ShipVista offers comprehensive insurance sold separately",
              "Schedule Delivery - Not Offered",
              "Handover Type - No pickup, Allows drop off",
              "Import Tax Handling - Only Receiver Can Pay the Taxes",
              "Delivery Attempts - Depends on Local Postal Service",
              "Height: Weight: 30 kg, Volume: 299 cm",
              "Prohibited Items : Stand-Alone Batteries are not allowed",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost USA work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost USA. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Xpresspost USA for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Xpresspost USA directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canada Post Xpresspost USA shipment?",
                desc: " You can track Canada Post Xpresspost USA shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Xpresspost USA shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Xpresspost USA shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Xpresspost USA shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Xpresspost USA shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Xpresspost USA, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Xpresspost USA delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Xpresspost USA. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Expedited Parcel",
          desc: "For Cost-effective Shipping within Canada",
          link: "/canada-post/canada-post-expedited-parcel",
          details: {
            title1: "Canada Post Expedited Parcel",
            para1:
              "This trackable service is Express service with a well-established internationally for documents. With their excellent customer service and quick delivery times, DHL stands out from the competition.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Courier Liability Insurance is not offered by Canada Post Expedited Parcel *ShipVista offers comprehensive insurance sold separately",
              "Schedule Delivery - Offered",
              "Handover Type - No pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts - Up to Three Attempts",
              "Height: 199 cm, Weight: 30 kg, Volume: 299 cm",
              "Prohibited Items : No battery",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "Express service with a well-established internationally for documents. With their excellent customer service and quick delivery times, DHL stands out from the competition.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Expedited Parcel work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Expedited Parcel. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Expedited Parcel for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Expedited Parcel directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title:
                  "How do I track a Canada Post Expedited Parcel shipment?",
                desc: " You can track Canada Post Expedited Parcel shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Expedited Parcel shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Expedited Parcel shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Expedited Parcel shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Expedited Parcel shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Expedited Parcel, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Expedited Parcel delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Expedited Parcel. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Tracked Packet",
          desc: "This is an affordable service for small and lightweight items.",
          link: "/canada-post/canada-post-tracked-packet",
          details: {
            title1: "Canada Post Tracked Packet",
            para1:
              "This trackable service is premium courier service for high priority items. Reliable shipping for small and lightweight parcels to the U.S.",
            features: [
              "Ideal for e-commerce shipping",
              "Projected arrival date - 4 – 7 business days for US destinations",
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Not Offered",
              "Handover Type - Free pickup, Allows drop off",
              "Import Tax Handling - Only Receiver Can Pay the Taxes",
              "Delivery Attempts - Up to Three Attempts",
              "Height: Weight: 30 kg",
              "Prohibited Items : No battery, liquids",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Tracked Packet work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Tracked Packet. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Tracked Packet for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Tracked Packet directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canada Post Tracked Packet shipment?",
                desc: " You can track Canada Post Tracked Packet shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Tracked Packet shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Tracked Packet shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Tracked Packet shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Tracked Packet shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Tracked Packet, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Tracked Packet delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Tracked Packet. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post International Small Packet Air",
          desc: "Economical solution for small and lightweight items.",
          link: "/canada-post/canada-post-international-small-packet-air",
          details: {
            title1: "Canada Post International Small Packet Air",
            para1:
              "The most well-liked service level, providing rapid transportation and milestone tracking at a large discount. options for DDU and DDP available globally",
            features: [
              "Pricing Budget *Economy to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Courier Liability Insurance is not offered by Canada Post International Small Packet Air *ShipVista offers comprehensive insurance sold separately",
              "Schedule Delivery - Offered",
              "Handover Type - Paid pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts - Depends on Local Postal Service",
              "Height: 20 cm, Length: 60 cm, Width: 10 cm, Weight: 2 kg, Volume: 90 cm",
              "Prohibited Items : Stand-Alone Batteries",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title:
                  "How does Canada Post International Small Packet Air work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post International Small Packet Air. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post International Small Packet Air for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post International Small Packet Air directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title:
                  "How do I track a Canada Post International Small Packet Air shipment?",
                desc: " You can track Canada Post International Small Packet Air shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post International Small Packet Air shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post International Small Packet Air shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post International Small Packet Air shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post International Small Packet Air shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post International Small Packet Air, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post International Small Packet Air delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post International Small Packet Air. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Expedited Parcel USA",
          desc: "Canada Post Expedited Parcel USA is non time sensitive parcel under 30 kg.",
          link: "/canada-post/canada-post-expedited-parcel-usa",
          details: {
            title1: "Canada Post Expedited Parcel USA",
            para1:
              "Fast shipping solution for you to ship your parcel to all destination",
            features: [
              "Pricing Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Offered",
              "Handover Type - Free pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts - Up to Three Attempts",
              "Weight: 30 kg, Length: 200 cm, Volume: 274 cm",
              "Prohibited Items : No battery",
              "Courier Liability - Insurance is not offered by Canada Post Expedited Parcel USA *ShipVista offers comprehensive insurance sold separately",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Expedited Parcel USA work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Expedited Parcel USA. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Expedited Parcel USA for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Expedited Parcel USA directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title:
                  "How do I track a Canada Post Expedited Parcel USA shipment?",
                desc: " You can track Canada Post Expedited Parcel USA shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Expedited Parcel USA shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Expedited Parcel USA shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Expedited Parcel USA shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Expedited Parcel USA shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Expedited Parcel USA, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Expedited Parcel USA delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Expedited Parcel USA. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Small Packet USA",
          desc: "Canada Post Small Packet USA is for small parcels under 2 kg.",
          link: "/canada-post/canada-post-small-packet-usa",
          details: {
            title1: "Canada Post Small Packet USA",
            para1: "Reliable service for domestic delivery",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Offered",
              "Handover Type - No pickup, Allows drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts - Depends on Local Service",
              "Weight: 2 kg, Length: 60 cm, Volume: 90 cm",
              "Prohibited Items : Stand-Alone batteries",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Small Packet USA work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Small Packet USA. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Small Packet USA for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Small Packet USA directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title:
                  "How do I track a Canada Post Small Packet USA shipment?",
                desc: " You can track Canada Post Small Packet USA shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Small Packet USA shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Small Packet USA shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Small Packet USA shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Small Packet USA shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Small Packet USA, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Small Packet USA delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Small Packet USA. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canada Post Priority Shipping",
          desc: "Urgent items arrives at the fastest speed",
          link: "/canada-post/canada-post-priority-shipping",
          details: {
            title1: "Canada Post Priority Shipping",
            para1:
              "Shipping is quick and assured to both domestic and foreign locations.",
            features: [
              "Pricing Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Insurance is not offered by Canada Post Priority Shipping *ShipVista offers comprehensive insurance sold separately",
              "Schedule Delivery - Offered",
              "Handover Type - Free pickup, Allows drop off",
              "Import Tax Handling - Only Receiver Can Pay the Taxes",
              "Delivery Attempts - Up to Three Attempts",
              "Height: 199 cm, Weight: 30 kg, Volume: 299 cm",
              "Prohibited Items : No battery",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Priority Shipping work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Priority Shipping. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title:
                  "How can I contact Canada Post Priority Shipping for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canada Post Priority Shipping directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title:
                  "How do I track a Canada Post Priority Shipping shipment?",
                desc: " You can track Canada Post Priority Shipping shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canada Post Priority Shipping shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canada Post Priority Shipping shipment and other services we offer.",
              },
              {
                title:
                  "What can I ship with Canada Post Priority Shipping shipment?",
                desc: "There aren't many limitations on what you can ship with Canada Post Priority Shipping shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canada Post Priority Shipping, none",
              },
              {
                title:
                  "Do we require a signature on Canada Post Priority Shipping delivery?",
                desc: "An optional signature-on-delivery service is provided by Canada Post Priority Shipping. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
      ],
      title: "Supported Canada Post Shipping Services",
      para: "Canada Post offers the following services through the ShipVista platform to ship within Canada, to USA, and worldwide.",
    },
    section5: {
      faqs: [
        {
          title: "How many Canada Post location are in Canada?",
          desc: "Canada Post has 6,200 post offices.",
        },
        {
          title: "Can I integrate my Canada Post account to ShipVista?",
          desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your Canpar account. It only takes a few minutes to link your Canpar account. For information, visit our help centre.",
        },
        {
          title: "How can I contact Canada Post?",
          desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with Canada Post directly while shipping with ShipVista. If you want to learn more, then you can visit the Canada Post website.",
        },
        {
          title: "How do I find my Canada Post tracking number?",
          desc: "You can track Canada Post shipments using the tracking number for the shipment provided and visiting the “Manage Shipments” section of the ShipVista dashboard.",
        },
        {
          title: "Does Canada Post deliver on weekends?",
          desc: "No, Canada Post does not offer delivery on the weekends",
        },
        {
          title: "Does Canada Post require a signature on delivery?",
          desc: "Canada Post shipments do not require a signature on delivery.",
        },
      ],
      title: "Frequently Asked Questions",
      para: "More on shipping with Canada Post - Common questions about Canada Post.",
    },
    section6: {
      title: "Integrate Canada Post Account on ShipVista",
      integration: {
        requirements: [
          "An active Commercial or Small Business account with Canada Post.",
          "Your Canada Post account login credentials.",
        ],
        connect: [
          {
            list: "Ensure that you are logged into the app and can see the main dashboard.",
          },
          {
            list: "Click the setting icon at the top right hand corner of the window to go to the settings pages.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/settings-cog.png",
          },
          {
            list: "Click the 'Integrations' button on the left hand side accordian to expand the integrations panel.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/click-intergrations.png",
          },
          {
            list: "Select the 'Carrier Setup' option in the panel that opens.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/select-carrier-setup.png",
          },
          {
            list: "Click the 'Connect Carrier Account' button near the top right hand corner of the screen.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/carrier-connect-button.png",
          },
          {
            list: "In the dialog that opens, select the Canada Post logo and a form should open.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/carriers/canadapost/carrier-list.png",
          },
          {
            list: "In the form, enter the correct information and proceed by clicking the 'Connect Account' button at the bottom of the form.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/carriers/canadapost/enter-name.png",
          },
        ],
        features: [
          {
            name: "Domestic Shipping",
            status: "Yes",
          },
          {
            name: "International Shipping",
            status: "Yes",
          },
          {
            name: "Electronic Customs Submission",
            status: "Yes",
          },
          {
            name: "Return Labels",
            status: "Yes",
          },
          {
            name: "Estimated Rates",
            status: "Yes",
          },
          {
            name: "Carrier Insurance",
            status: "Yes",
          },
          {
            name: "Tracking",
            status: "Yes",
          },
          {
            name: "Automatic Tracking",
            status: "Yes",
          },
          {
            name: "End of Day (Electronic)",
            status: "Yes",
          },
          {
            name: "End of Day (PDF)",
            status: "Yes",
          },
          {
            name: "Label Branding",
            status: "Yes",
          },
          {
            name: "Label Messages",
            status: "Yes",
          },
          {
            name: "Multi-package Shipping",
            status: "Yes",
          },
          {
            name: "Multiple Accounts",
            status: "Yes",
          },
        ],
        additionalDetails:
          "It is advisable to import orders through ShipVista only.",
        troubleshooting:
          "Please contact our customer care team if any issues arise. Visit the support page for contact details.",
      },
    },
  },
};

export const canpar = {
  en: {
    hero: {
      title:
        "ShipVista is a certified Canada Post partner. Activate your account and start saving on shipments today.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/carrier-logos/carrier-canpar.jpg",
    },
    section1: {
      note: "ShipVista is a certified Canpar partner. Activate your account and start saving on shipments today.",
      title: "About Canpar",
      para: "Canpar Express is one of the top small parcel delivery providers in Canada and has been providing reliable Ground, Select, and Express service to consumers from coast to coast for more than 40 years.Canpar Express offers a economical and reliable alternative for your regular daily shipping requirements to practically any site reachable by public road serving the provinces of Canada.",
    },
    section2: {
      title:
        "Use your Negotiated Rates with Canpar Express Shipping & ShipVista",
      para: "With ShipVista, you can power your label production, courier comparison, and shipping automation's for both domestic and international shipments while getting the lowest available Canpar Express prices. ShipVista offers Canpar Express shipping speed and cost savings.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canparimage.png",
    },
    section3: {
      title: "Features of Canpar that ShipVista supports",
      para: "Canpar Express offers the various services through the ShipVista platform to ship within Canada.Shipping with Canpar Express on ShipVista is just the beginning",
      list: [
        {
          title: "Automate repetitive tasks with ShipVista",
          desc: "",
        },
        {
          title:
            "Expand your business using ShipVista global fulfillment network",
          desc: "",
        },
        {
          title: "Sync orders directly from your store",
          desc: "",
        },
        {
          title: "Full Clarity on import tax & duties",
          desc: "",
        },
        {
          title: "Best-in-class shipping solution",
          desc: "",
        },
        {
          title:
            "All backed by excellent customer support and unique ticketing system",
          desc: "",
        },
      ],
      note: "",
      list2: [
        "Paperless Billing",
        "Multiple Services",
        "Real-Time Tracking",
        "Electronic Proof of Delivery",
      ],
      disclaimer: "",
    },
    section4: {
      services: [
        {
          title: "Canpar Overnight",
          desc: "Overnight Service within Canada",
          link: "/canpar/canpar-overnight",
          details: {
            title1: "Canpar Overnight",
            para1:
              "An express service for all your domestic shipments delivered within 1-7 days.",
            features: [
              "Pricing Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Not Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Import Tax Handling - No Import Tax",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/Canpar-services.png",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canpar Overnight Rates with ShipVista",
            faqs: [
              {
                title: "How does Canpar Overnight work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canpar Overnight. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact Canpar Overnight for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canpar Overnight directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canpar Overnight shipment?",
                desc: " You can track Canpar Overnight shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canpar Overnight shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canpar Overnight shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a Canpar Overnight shipment to United States?",
                desc: "Shipments for Canpar Overnight shipments to Canada generally take between 1 - 6 days. Sign up for an ShipVista account to see the most accurate delivery time for Canpar Overnight shipment.",
              },
              {
                title: "What can I ship with Canpar Overnight shipment?",
                desc: "There aren't many limitations on what you can ship with Canpar Overnight shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canpar Overnight, none",
              },
              {
                title:
                  "Do we require a signature on Canpar Overnight delivery?",
                desc: "An optional signature-on-delivery service is provided by Canpar Overnight. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canpar Ground",
          desc: "Ground Services across Canada",
          link: "/canpar/canpar-ground",
          details: {
            title1: "Canpar Ground",
            para1:
              "An express service for all your domestic shipments delivered within 1-7 days.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Not Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Import Tax Handling - No Import Tax",
            ],
            title2: "What does this mean for your business?",
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/Canpar-services.png",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canpar Ground Rates with ShipVista",
            faqs: [
              {
                title: "How does Canpar Ground work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canpar Ground. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact Canpar Ground for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canpar Ground directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canpar Ground shipment?",
                desc: " You can track Canpar Ground shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canpar Ground shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canpar Ground shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a Canpar Ground shipment to United States?",
                desc: "Shipments for Canpar Ground shipments to Canada generally take between 1 - 4 days. Sign up for an ShipVista account to see the most accurate delivery time for Canpar Ground shipment.",
              },
              {
                title: "What can I ship with Canpar Ground shipment?",
                desc: "There aren't many limitations on what you can ship with Canpar Ground shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canpar Ground, none",
              },
              {
                title: "Do we require a signature on Canpar Ground delivery?",
                desc: "An optional signature-on-delivery service is provided by Canpar Ground. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canpar Select",
          desc: "For Shipments to be delivered the next business day within your region.",
          link: "/canpar/canpar-select",
          details: {
            title1: "Canpar Select",
            para1:
              "An express service for all your domestic shipments delivered within 1-7 days.",
            features: [
              "Pricing Economy *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Not Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Import Tax Handling - No Import Tax",
              "Delivery Attempts Depends on Local Service",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/Canpar-services.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canpar Select Rates with ShipVista",
            faqs: [
              {
                title: "How does Canpar - Select work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canpar - Select. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact Canpar - Select for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canpar - Select directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canpar - Select shipment?",
                desc: " You can track Canpar - Select shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canpar - Select shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canpar - Select shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a Canpar - Select shipment to United States?",
                desc: "Shipments for Canpar - Select shipments to Canada generally take between 1 - 6 days. Sign up for an ShipVista account to see the most accurate delivery time for Canpar - Select shipment.",
              },
              {
                title: "What can I ship with Canpar - Select shipment?",
                desc: "There aren't many limitations on what you can ship with Canpar - Select shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canpar - Select, none",
              },
              {
                title: "Do we require a signature on Canpar - Select delivery?",
                desc: "An optional signature-on-delivery service is provided by Canpar - Select. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
        {
          title: "Canpar International",
          desc: "Economy Solution for International Shipments",
          link: "/canpar/canpar-international",
          details: {
            title1: "Canpar International",
            para1:
              "An express service for all your domestic shipments delivered within 1-7 days.",
            features: [
              "Pricing Premium *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
              "Recall Policy - No",
              "Schedule Delivery - Not Offered",
              "Handover Type - Offers free pickup, No drop off",
              "Import Tax Handling - No Import Tax",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/Canpar-services.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canpar rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canpar International Rates with ShipVista",
            faqs: [
              {
                title: "How does Canpar International work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canpar International. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
              {
                title: "How can I contact Canpar International for a shipment?",
                desc: "When shipping with ShipVista, you do not need to contact Canpar International directly as all shipment information and actions you will need to take are available to you directly on the ShipVista platform. If you want to learn more, then you can visit the UPS website.",
              },
              {
                title: "How do I track a Canpar International shipment?",
                desc: " You can track Canpar International shipments using the tracking number for the shipment provided and visiting the ShipVista Platform.",
              },
              {
                title:
                  "What are the shipping rates for Canpar International shipment?",
                desc: "Rates varies based on shipment details and destination. Sign up today for a free ShipVista account to see the live rates for Canpar International shipment and other services we offer.",
              },
              {
                title:
                  "How long will delivery take for a Canpar International shipment to United States?",
                desc: "Delivery time varies on origin and destination. Sign up for an ShipVista account to see the most accurate delivery time for Canpar International shipment.",
              },
              {
                title: "What can I ship with Canpar International shipment?",
                desc: "There aren't many limitations on what you can ship with Canpar International shipment, but you should be aware that most places have restrictions on things like alcohol, food, and other commodities. With Canpar International, none",
              },
              {
                title:
                  "Do we require a signature on Canpar International delivery?",
                desc: "An optional signature-on-delivery service is provided by Canpar International. The sender will select at the time of shipment production whether or not a signature on delivery will be necessary for release.",
              },
            ],
          },
        },
      ],
      title: "Canpar Express Shipping Options available through ShipVista",
      para: "",
    },
    section5: {
      faqs: [
        {
          title: "What is Pickup Tag Service?",
          desc: "Canpar Express provides a number of pick-up tag choices that let you recover a package using our Ground service while having the costs charged to your account. Through your own MyCanpar portal, simply enter the address information for the pick-up tag, and our driver will arrive the following business day with the label to collect the delivery.",
        },
        {
          title: "What is Collect Service?",
          desc: "You can allow third parties to schedule their own pick-ups based on the services you have authorized using Canpar Express's online Collect Service. It is that simple. You are also emailed a daily activity summary for easy tracking and viewing of your collect shipments.",
        },
        {
          title: "What is Chain of Signature?",
          desc: "The Chain of Signature service ensures that any staff member of Canpar Express who handles the flagged package must sign the Chain of Signature label which is affixed to each package in the shipment...",
        },
        {
          title: "What is Pick Up on Demand service?",
          desc: "Canpar Pick Up on Demand service allows non-account holders the ability to ship on a flexible, pay-as-you-go basis. Simply fill in the shipping details and proceed to our secured checkout where you can pay by major credit card.",
        },
        {
          title: "Can I integrate my Canpar account to ShipVista?",
          desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your Canpar account. It only takes a few minutes to link your Canpar account. For information, visit our help centre.",
        },
        {
          title: "How can I contact Canpar Express?",
          desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with Canpar Express directly while shipping with ShipVista. If you want to learn more, then you can visit the Canpar Express website.",
        },
        {
          title: "How do I find my Canpar Express tracking number?",
          desc: "You can track Canpar Express shipments using the tracking number for the shipment provided and visiting the “Manage Shipments” section of the ShipVista dashboard.",
        },
        {
          title: "Does Canpar Express deliver on weekends?",
          desc: "No, Canpar Express does not offer delivery on the weekends",
        },
        {
          title: "Does Canpar Express require a signature on delivery?",
          desc: "Canpar Express shipments do not require a signature on delivery.",
        },
      ],
      title: "Frequently Asked Questions",
      para: "About Canpar Specialized Services",
    },
    section6: {
      title: "Integrate Canpar Account on ShipVista",
      integration: {
        requirements: [
          "An active Commercial or Small Business account with Canpar.",
          "Your Canpar account login credentials.",
        ],
        connect: [
          {
            list: "Ensure that you are logged into the app and can see the main dashboard.",
          },
          {
            list: "Click the setting icon at the top right hand corner of the window to go to the settings pages.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/settings-cog.png",
          },
          {
            list: "Click the 'Integrations' button on the left hand side accordian to expand the integrations panel.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/click-intergrations.png",
          },
          {
            list: "Select the 'Carrier Setup' option in the panel that opens.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/select-carrier-setup.png",
          },
          {
            list: "Click the 'Connect Carrier Account' button near the top right hand corner of the screen.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tutorialImages/carrier-connect-button.png",
          },
          {
            list: "In the dialog that opens, select the Canpar logo and a form should open.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/connect-canpar.png",
          },
          {
            list: "In the form, enter the correct information and proceed by clicking the 'Connect Account' button at the bottom of the form.",
            img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/Canpar-enter-correct-information.png",
          },
        ],
        features: [
          {
            name: "Domestic Shipping",
            status: "Yes",
          },
          {
            name: "International Shipping",
            status: "Yes",
          },
          {
            name: "Electronic Customs Submission",
            status: "Yes",
          },
          {
            name: "Return Labels",
            status: "Yes",
          },
          {
            name: "Estimated Rates",
            status: "Yes",
          },
          {
            name: "Carrier Insurance",
            status: "Yes",
          },
          {
            name: "Tracking",
            status: "Yes",
          },
          {
            name: "Automatic Tracking",
            status: "Yes",
          },
          {
            name: "End of Day (Electronic)",
            status: "Yes",
          },
          {
            name: "End of Day (PDF)",
            status: "Yes",
          },
          {
            name: "Label Branding",
            status: "Yes",
          },
          {
            name: "Label Messages",
            status: "Yes",
          },
          {
            name: "Multi-package Shipping",
            status: "Yes",
          },
          {
            name: "Multiple Accounts",
            status: "Yes",
          },
        ],
        additionalDetails:
          "It is advisable to import orders through ShipVista only.",
        troubleshooting:
          "Please contact our customer care team if any issues arise. Visit the support page for contact details.",
      },
    },
  },
};

export const tForce = {
  en: {
    hero: {
      title:
        "ShipVista is a certified TForce partner. Activate your account and start saving on shipments today.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tforce/tforce.png",
    },
    section1: {
      note: "ShipVista is a certified TForce partner. Activate your account and start saving on shipments today.",
      title: "About TForce Freight",
      para: "TForce Freight’s extensive transportation network, experienced employees, and efficient systems mean your freight will be picked up and delivered on time. As a global leader in logistics, TForce Freight is committed to making your less-than-truckload (LTL) shipments easier and improving your efficiency—delivering more solutions and more results at every turn.",
    },
    section2: {
      title: "What is a LTL shipment? How do I prepare an LTL Shipment?",
      para: "LTL stands for 'Less-Than-Truckload' and typically refers to palletized freight weighing over 150 pounds.  Most LTL shipments are palletized, making preparation slightly more complicated than a small package shipment.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tforce/Truck-Less-than-truckload-shipping.webp",
    },
    section3: {
      title: "TForce Freight shipping offers:",
      para: "TForce Freight’s extensive transportation network, experienced employees, and efficient systems mean your freight will be picked up and delivered on time.",
      list: [
        {
          title:
            "Regional, interregional & long-haul service, all with one pickup",
          desc: "",
        },
        {
          title: "More than 15,000 one and two day lanes",
          desc: "",
        },
        {
          title: "Cross-continent three- and four-day service",
          desc: "",
        },
        {
          title: "Technologies to improve shipping, tracking & billing",
          desc: "",
        },
        {
          title: "Single carrier responsibility",
          desc: "",
        },
        {
          title: "Offshore and international shipping",
          desc: "",
        },
      ],

      note: "",
      list2: [
        "Paperless Billing",
        "Multiple Services",
        "Real-Time Tracking",
        "Electronic Proof of Delivery",
      ],
      disclaimer: "",
    },
    section3a: {
      title: "TForce Freight shipping features:",
      para: "Whether it’s a major market or rural location, TForce Freight provides reliable service and direct pricing for shipments moving between the United States and Canada.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/tforce/north-america-map.jpg",
      alt1: "map of TForce centers",
      list: [
        {
          title: "100% full-province coverage for all of Canada",
          desc: "",
        },
        {
          title: "All locations are customs-bonded facilities",
          desc: "",
        },
        {
          title:
            "PARS (Pre-Arrival System) clearance at border crossings to speed transit times and minimize delays",
          desc: "",
        },
        {
          title:
            "C-TPAT, PIP, CSA and FAST approved carrier minimizes customs delays and ensures compliance",
          desc: "",
        },
        {
          title: "Complete online tracking from origin to destination",
          desc: "",
        },
        {
          title:
            "Complete document imaging system for instant access to all customs documents",
          desc: "",
        },
        {
          title: "All freight charges appear on a single, simplified invoice",
          desc: "",
        },
      ],
    },
    section4: {
      title: "TForce Freight LTL Products",
      para: "TForce Freight offers the below products with ShipVista",
      services: [
        {
          title: "TForce Freight LTL",
          desc: "Standard regional, interregional and long-haul LTL service",
          link: "/tforce/tforce-freight-ltl",
          details: {
            // sample, actual data is in fulfillment-partner.json
            title1: "Canada Post Xpresspost",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "TForce Freight LTL Guaranteed",
          desc: "Guaranteed day-definite delivery",
          link: "/tforce/tforce-freight-ltl-guaranteed",
          details: {
            // sample, actual data is in fulfillment-partner.json
            title1: "Canada Post Xpresspost",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "TForce Freight LTL Expedited",
          desc: "Expedited, multi-modal service, including guaranteed delivery for specified time and location",
          link: "/tforce/tforce-freight-ltl-expedited",
          details: {
            // sample, actual data is in fulfillment-partner.json
            title1: "Canada Post Xpresspost",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
      ],
    },
    section5: {
      faqs: [
        {
          title: "Is TForce Freight owned by UPS?",
          desc: "TForce Freight, a subsidiary of TFI International, is an American less than truckload (LTL) freight carrier based in Richmond, Virginia. The company was founded in 1935 as Overnite Transportation, the name it used until 2006 when it was rebranded UPS Freight by new owner UPS.",
        },
        {
          title: "Can I integrate my TForce account to ShipVista?",
          desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your TForce account. It only takes a few minutes to link your TForce account. For information, visit our help centre.",
        },
        {
          title: "How can I contact TForce Freight?",
          desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with TForce directly while shipping with ShipVista. If you want to learn more, then you can visit the TForce website.",
        },
        {
          title: "Does TForce Freight deliver on holidays?",
          desc: "For most holidays, delivery service is not available unless scheduled in advance with TForce Freight Expedited. Additional charges may apply for pickup and delivery services on major holidays.",
        },
      ],
      title: "Frequently Asked Questions",
      para: "More on shipping with TForce Freight - Common questions about TForce Freight.",
    },
    section6: {
      title: "Integrate Canada Post Account on ShipVista",
      integration: {
        requirements: [
          "An active Commercial or Small Business account with Canada Post.",
          "Your Canada Post account login credentials.",
        ],
        connect: [
          {
            list: "Ensure that you are logged into the app and can see the main dashboard.",
          },
          {
            list: "Click the setting icon at the top right hand corner of the window to go to the settings pages.",
            img: "https://shipvista.com/images/partners/tutorialImages/settings-cog.png",
          },
          {
            list: "Click the 'Integrations' button on the left hand side accordian to expand the integrations panel.",
            img: "https://shipvista.com/images/partners/tutorialImages/click-intergrations.png",
          },
          {
            list: "Select the 'Carrier Setup' option in the panel that opens.",
            img: "https://shipvista.com/images/partners/tutorialImages/select-carrier-setup.png",
          },
          {
            list: "Click the 'Connect Carrier Account' button near the top right hand corner of the screen.",
            img: "https://shipvista.com/images/partners/tutorialImages/carrier-connect-button.png",
          },
          {
            list: "In the dialog that opens, select the Canada Post logo and a form should open.",
            img: "https://shipvista.com/images/partners/tutorialImages/carriers/canadapost/carrier-list.png",
          },
          {
            list: "In the form, enter the correct information and proceed by clicking the 'Connect Account' button at the bottom of the form.",
            img: "https://shipvista.com/images/partners/tutorialImages/carriers/canadapost/enter-name.png",
          },
        ],
        features: [
          {
            name: "Domestic Shipping",
            status: "Yes",
          },
          {
            name: "International Shipping",
            status: "Yes",
          },
          {
            name: "Electronic Customs Submission",
            status: "Yes",
          },
          {
            name: "Return Labels",
            status: "Yes",
          },
          {
            name: "Estimated Rates",
            status: "Yes",
          },
          {
            name: "Carrier Insurance",
            status: "Yes",
          },
          {
            name: "Tracking",
            status: "Yes",
          },
          {
            name: "Automatic Tracking",
            status: "Yes",
          },
          {
            name: "End of Day (Electronic)",
            status: "Yes",
          },
          {
            name: "End of Day (PDF)",
            status: "Yes",
          },
          {
            name: "Label Branding",
            status: "Yes",
          },
          {
            name: "Label Messages",
            status: "Yes",
          },
          {
            name: "Multi-package Shipping",
            status: "Yes",
          },
          {
            name: "Multiple Accounts",
            status: "Yes",
          },
        ],
        additionalDetails:
          "It is advisable to import orders through ShipVista only.",
        troubleshooting:
          "Please contact our customer care team if any issues arise. Visit the support page for contact details.",
      },
    },
  },
};

export const purolator = {
  en: {
    hero: {
      title:
        "ShipVista is a certified Purolator partner. Activate your account and start saving on shipments today.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/carrier-logos/Purolator-logo.png",
    },
    section1: {
      note: "ShipVista is a certified Purolator partner. Activate your account and start saving on shipments today.",
      title: "About Purolator",
      para: "Purolator is a Canadian courier company that provides shipping and logistics services. It is one of the leading courier companies in Canada and offers a wide range of services to businesses and individuals alike. The company offers various shipping options, including express shipping, ground shipping, freight services, and specialized services for specific industries such as healthcare and retail. In addition to its shipping services, Purolator provides logistics solutions to businesses, helping them manage their supply chain and optimize their operations. This includes warehousing, inventory management, customs clearance, and other value-added services.",
    },
    section2: {
      title:
        "Get access the cheapest Purolator shipping rates when using ShipVista",
      para: "ShipVista's shipping platform can give you access to the cheapest Purolator rates for both domestic and international shipments from Canada. You can ship your order with confidence knowing that you are getting the best savings regardless of you shipping needs.",
      img1: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/purolator/purolator-illustration-centered.png",
    },
    section3: {
      title: "Features of Purolator that ShipVista supports",
      para: "Purolator is a leading integrated freight, package and logistics provider, which offers the various services through the ShipVista platform to ship within Canada.",
      list: [
        {
          title: "Automate repetitive tasks with ShipVista",
          desc: "",
        },
        {
          title:
            "Expand your business using ShipVista global fulfillment network",
          desc: "",
        },
        {
          title: "Sync orders directly from your store",
          desc: "",
        },
        {
          title: "Full Clarity on import tax & duties",
          desc: "",
        },
        {
          title: "Best-in-class shipping solution",
          desc: "",
        },
        {
          title:
            "All backed by excellent customer support and unique ticketing system",
          desc: "",
        },
      ],
      note: "",
      list2: [
        "Paperless Billing",
        "Multiple Services",
        "Real-Time Tracking",
        "Electronic Proof of Delivery",
      ],
      disclaimer: "",
    },
    section4: {
      services: [
        {
          title: "Purolator Express 9AM",
          desc: "When you need early morning, next-business-day delivery. Receive guaranteed delivery to select Canadian destinations by 9 a.m. the next business day",
          link: "/purolator/purolator-express-9am",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Express 10:30AM",
          desc: "Receive guaranteed delivery to select destinations in Canada by 10:30 a.m. the next business day.",
          link: "/purolator/purolator-express-1030am",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Express",
          desc: "Receive guaranteed delivery to most destinations in Canada by the end of the next business day.",
          link: "/purolator/purolator-express",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Express Evening",
          desc: "Receive guaranteed delivery between 5:30 p.m. and 9 p.m. the next business day.",
          link: "/purolator/purolator-express-evening",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Express 12PM",
          desc: "Receive guaranteed delivery to select destinations in Canada by noon the next business day.",
          link: "/purolator/purolator-express-12pm",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Ground",
          desc: "For less time-sensitive shipment. With this alternative, shipments can arrive by the end of one business day or more, depending on your destination.",
          link: "/purolator/purolator-ground",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Ground Evening",
          desc: "For non-regional shipment to be delivered during the evening hours. Receive guaranteed delivery between 5:30 p.m. and 9 p.m. in two or more business days, depending on your destination.",
          link: "/purolator/purolator-ground-evening",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Ground 9AM",
          desc: "For non-regional shipment to arrive first thing in the morning in two or more business days. Receive guaranteed delivery by 9 a.m. in two or more business days, depending on your destination.",
          link: "/purolator/purolator-ground-9am",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Ground 10:30AM",
          desc: "For non-regional shipment to arrive by mid-morning in two or more business days. Receive guaranteed delivery by 10:30 a.m. in two or more business days, depending on your destination.",
          link: "/purolator/purolator-ground-1030am",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
        {
          title: "Purolator Express U.S.",
          desc: "For shipment delivered to the U.S. the next business day. Offers next-business-day delivery to most destinations in the U.S. with guaranteed delivery by the end of the day.",
          link: "/purolator/purolator-express-us",
          details: {
            // sample, actual data is in fulfillment-partner.json
            bannerColor: "#ABBEEC",
            title1: "Purolator Express 9AM",
            para1:
              "This trackable service is the ideal choice for reliable, economical deliveries across Canada.",
            features: [
              "Pricing Budget *Compared to other courier services available on the ShipVista platform",
              "Pricing Calculation - by volumetric weight",
            ],
            image1:
              "https://cbpstaticfiles.blob.core.windows.net/sv-app/site-images/canada-post.png",
            title2: "What does this mean for your business?",
            para2:
              "As a user of the ShipVista platform, you can connect your Canada Post rates while enjoying seamless connectivity within ShipVista's shipping solution.",
            accessBtnText: "Access Canada Post Rates with ShipVista",
            faqs: [
              {
                title: "How does Canada Post Xpresspost work?",
                desc: "You must enter your shipment information (such as address and item details) and buy a shipping label in order to create a shipment with Canada Post Xpresspost. Print your shipping labels, affix them to your item, and then deliver it to a drop-off site that has been provided. Locations for drop-off can be found here. UPS will then organize shipping to your final destination. The ShipVista platform can be used to manage the entire procedure.",
              },
            ],
          },
        },
      ],
      title: "Supported Purolator Shipping Services",
      para: "Purolator offers the following services through the ShipVista platform to ship to, from, and within Canada.",
    },
    section5: {
      faqs: [
        {
          title: "Can I integrate my Purolator account to ShipVista?",
          desc: "With ShipVista, merchants get immediate access to courier accounts. You may still use ShipVista to calculate rates, create labels, and manage tracking in addition to all of the other features the platform offers by connecting your Purolator account. It only takes a few minutes to link your Purolator account. For information, visit our help centre.",
        },
        {
          title: "How can I contact Purolator?",
          desc: "You can access all the necessary shipment information and activities on the ShipVista platform, so you won't need to get in touch with Purolator directly while shipping with ShipVista. If you want to learn more, then you can visit the Purolator website.",
        },
        {
          title: "How do I find my Purolator tracking number?",
          desc: "You can track Purolator shipments using the tracking number for the shipment provided and visiting the “Manage Shipments” section of the ShipVista dashboard.",
        },
        {
          title: "How can I find the a shipping location near me?",
          desc: "Purolator has over 1,300 convenient shipping locations across Canada. You can find the nearest one by visiting https://www.purolator.com/en/shipping/find-shipping-centre.",
        },
        {
          title: "How can I sign up for a Purolator Business Account?",
          desc: "Visit the Purolator website to open an account if you do not have one. You may also use ShipVista's default Purolator account when shipping.",
        },
      ],
      title: "Frequently Asked Questions",
      para: "More on shipping with Purolator - Common questions about Purolator.",
    },
    section6: {
      title: "Integrate Canada Post Account on ShipVista",
      integration: {
        requirements: [
          "An active Commercial or Small Business account with Canada Post.",
          "Your Canada Post account login credentials.",
        ],
        connect: [
          {
            list: "Ensure that you are logged into the app and can see the main dashboard.",
          },
          {
            list: "Click the setting icon at the top right hand corner of the window to go to the settings pages.",
            img: "https://shipvista.com/images/partners/tutorialImages/settings-cog.png",
          },
          {
            list: "Click the 'Integrations' button on the left hand side accordian to expand the integrations panel.",
            img: "https://shipvista.com/images/partners/tutorialImages/click-intergrations.png",
          },
          {
            list: "Select the 'Carrier Setup' option in the panel that opens.",
            img: "https://shipvista.com/images/partners/tutorialImages/select-carrier-setup.png",
          },
          {
            list: "Click the 'Connect Carrier Account' button near the top right hand corner of the screen.",
            img: "https://shipvista.com/images/partners/tutorialImages/carrier-connect-button.png",
          },
          {
            list: "In the dialog that opens, select the Canada Post logo and a form should open.",
            img: "https://shipvista.com/images/partners/tutorialImages/carriers/canadapost/carrier-list.png",
          },
          {
            list: "In the form, enter the correct information and proceed by clicking the 'Connect Account' button at the bottom of the form.",
            img: "https://shipvista.com/images/partners/tutorialImages/carriers/canadapost/enter-name.png",
          },
        ],
        features: [
          {
            name: "Domestic Shipping",
            status: "Yes",
          },
          {
            name: "International Shipping",
            status: "Yes",
          },
          {
            name: "Electronic Customs Submission",
            status: "Yes",
          },
          {
            name: "Return Labels",
            status: "Yes",
          },
          {
            name: "Estimated Rates",
            status: "Yes",
          },
          {
            name: "Carrier Insurance",
            status: "Yes",
          },
          {
            name: "Tracking",
            status: "Yes",
          },
          {
            name: "Automatic Tracking",
            status: "Yes",
          },
          {
            name: "End of Day (Electronic)",
            status: "Yes",
          },
          {
            name: "End of Day (PDF)",
            status: "Yes",
          },
          {
            name: "Label Branding",
            status: "Yes",
          },
          {
            name: "Label Messages",
            status: "Yes",
          },
          {
            name: "Multi-package Shipping",
            status: "Yes",
          },
          {
            name: "Multiple Accounts",
            status: "Yes",
          },
        ],
        additionalDetails:
          "It is advisable to import orders through ShipVista only.",
        troubleshooting:
          "Please contact our customer care team if any issues arise. Visit the support page for contact details.",
      },
    },
  },
};

export const shipvistaConnectPage = {
  en: {
    section1: {
      heading: "We help you fulfill your commitments to your customers.",
      para1:
        "Whether you’re a seasoned retailer or a new player in the market, whether you operate across multiple channels or focus solely online, we understand the effort you put into outpacing your competition and turning shoppers into loyal customers. Let us support you in the final, crucial phase of the purchasing process.",
      para2:
        "From your warehouse to your customer's doorstep—ShipVista Connect handles every step with top-tier delivery services, all at a highly competitive price. Whether you prefer to drop off your packages at our hub or need us to pick them up from your location, we ensure your parcels reach their destination efficiently, anywhere across Canada.",
      buttonTitle: "Explore Our Services",
      img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/SV_Connect_Services.jpeg",
    },
    section2: {
      heading:
        "Canadian Businesses: Get Flexible Shipping, All Perks Included with ShipVista Connect",
      iconList: [
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/calendar.png",
          heading: "7 days a week",
          sub: "That's 365 days a year, rain or shine.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/All-across-Canada.png",
          heading: "All across Canada",
          sub: "Reach 90% of Canadians thanks to our nationwide network.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/tracking.png",
          heading: "Real-time tracking",
          sub: "Follow every parcel right to customers' doors.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/pick-up.png",
          heading: "Free Package Pickup",
          sub: "Save time- have your packages collected right from your doorstep.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/advice.png",
          heading: "Expert Shipping Advice",
          sub: "Guidance from knowledgeable ShipVista® representatives.",
        },
        {
          img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/Competitive-pricing.png",
          heading: "Competitive Pricing",
          sub: "Cost-effective shipping solutions tailored to your needs.",
        },
      ],
    },
    sectin3: {
      heading: "Choose the Best Shipping Service for Your Needs",
      para: "ShipVista Connect offers a variety of shipping services designed to meet the diverse needs of businesses across Canada. Whether you're looking for fast delivery, cost-effective options, or specialized services, we have a solution for you. Compare our services below to find the best match for your business.Our advanced network gives you unparalleled access to rapid delivery options. Benefit from:",
      points: [
        {
          head: "Same- or next-day local delivery:",
          sub: "Reach customers in your area faster than ever before.",
        },
        {
          head: "Next-day regional delivery:",
          sub: "Expand your reach and serve customers across the region with lightning-fast shipping.",
        },
        {
          head: "Package Tracking and Management",
          sub: "Stay informed about your shipments with real-time tracking and easy-to-use management tools",
        },
        {
          head: "Flexible Pickup and Delivery Options",
          sub: "Choose from convenient pickup and delivery options that fit your business needs.",
        },
      ],
      img: "https://cbpstaticfiles.blob.core.windows.net/sv-app/partners/shipvista-connect/SVConnect_eCommerceTrusted.jpeg",
    },
    section4: {
      heading: "Available Features on ShipVista Connect",
      para: "ShipVista Connect supports the following standard features:",
      tableHeading: "Features at a Glance",
      table: {
        col: ["Feature", "Supported?"],
        content: [
          ["Domestic Shipping", "Yes"],
          ["International Shipping", "No"],
          ["Electronic Customs Submission", "Yes"],
          ["Return Labels", "Yes"],
          ["Estimated Rates", "Yes"],
          ["Carrier Insurance", "Yes"],
          ["Tracking", "Yes"],
          ["Automatic Tracking", "Yes"],
          ["Same Day Delivery", "Yes"],
        ],
      },
      tableHeading2: "Service Comparison",
      tableService: {
        col: [
          "Service",
          "Delivery Speed",
          "Coverage Area",
          "Tracking",
          "Price",
          "Ideal For",
        ],
        content: [
          [
            "Express Delivery",
            "Next-Day Delivery",
            "Nationwide",
            "Real-Time Tracking",
            "Premium",
            "Urgent Shipments",
          ],
          [
            "Standard Delivery",
            "2-5 Business Days",
            "Nationwide",
            "Real-Time Tracking",
            "Economical",
            "General Shipments",
          ],
          [
            "Same-Day Delivery",
            "Same Day",
            "Selected Cities",
            "Real-Time Tracking",
            "Moderate",
            "Immediate Needs",
          ],
        ],
      },
    },
    section5: {
      heading: "Why Choose ShipVista Connect?",
      para: "At ShipVista Connect, we understand that every business has unique shipping requirements. That's why we offer flexible, reliable, and cost-effective shipping solutions tailored to your needs. Whether you need rapid delivery, broad coverage, or specialized handling, we’ve got you covered.",
      heading2A: "Connection Requirements:",
      point: ["A active ShipVista account with ShipVista Connect", "Red"],
      heading2B: "Shipping Requirements:",
      point1: [
        "Packages shipped with ShipVista Connect can have a maximum weight of 149 lbs and not contain any dangerous goods.",
      ],
      point2: [
        "Pickups can be scheduled for 35 or more shipments. For fewer shipments, please drop them off at our warehouse.",
        "Red",
      ],
    },
    section6: {
      heading: "Ready to get on the right track?",
      sub: "Please fill out this short form to help us understand your business needs.",
      checkboxOpt: [
        {
          order: 0,
          name: "Urban",
        },
        {
          order: 1,
          name: "Suburban",
        },
        {
          order: 2,
          name: "Rural",
        },
      ],
    },
    section7: {
      heading: "Frequently Asked Questions (FAQs)",
      para: "Find answers to common questions about ShipVista Connect's services and shipping solutions",
      faqs: [
        {
          question: "What shipping options does ShipVista Connect offer?",
          answer:
            "Shipvista connect offers ground delivery services. We ensure that your packages are delivered on time, across Canada.",
        },
        {
          question: "How can I track my shipment?",
          answer:
            "You can easily track your shipment by using the tracking number provided in your confirmation email. Enter the tracking number on our tracking page to get real-time updates on your delivery status.",
        },
        {
          question: "What should I do if I missed a delivery?",
          answer:
            "If you missed a delivery, don’t worry! Our delivery partner will attempt to redeliver your package. You can also reschedule the delivery or arrange to pick it up at a nearby location. Details will be provided in the missed delivery notice.",
        },
        {
          question:
            "Can I change the delivery address after the shipment has been dispatched?",
          answer:
            "Yes, you can change the delivery address under certain conditions. Please contact our customer support team as soon as possible to request a change. Additional fees may apply depending on the new destination.",
        },
        {
          question: "What are your delivery hours?",
          answer:
            "Our standard delivery hours are between 10 AM and 8 PM, Monday to Saturday. If your package requires a special delivery time, please contact our support team to make arrangements",
        },
        {
          question: "What should I do if my package is damaged or lost?",
          answer:
            "If your package is damaged or lost, please contact our support team immediately. We will initiate an investigation and work with you to resolve the issue as quickly as possible. Depending on the case, we may offer a replacement or a refund.",
        },

        {
          question: "How do I contact ShipVista for business inquiries?",
          answer:
            "For business inquiries, please fill out our contact form or reach out directly to our sales team. We're here to help tailor our services to meet your business needs.",
        },
        {
          question: "What areas do you service?",
          answer: "ShipVista offers nationwide coverage across Canada.",
        },
      ],
    },
    SHIPMENT_INDUSTRY_OPTIONS: [
      { value: "", label: "Select..." },
      { value: "arts-and-crafts", label: "Arts and crafts" },
      { value: "baby-and-kids", label: "Baby and kids" },
      { value: "books-music-and-video", label: "Books, music, and video" },
      {
        value: "business-equipment-and-supplies",
        label: "Business equipment and supplies",
      },
      { value: "clothing", label: "Clothing" },
      { value: "electronics", label: "Electronics" },
      { value: "food-and-drink", label: "Food and drink" },
      { value: "hardware-and-automotive", label: "Hardware and automotive" },
      { value: "health-and-beauty", label: "Health and beauty" },
      { value: "home-and-decor", label: "Home and decor" },
      { value: "jewelry-and-accessories", label: "Jewelry and accessories" },
      { value: "outdoor-and-garden", label: "Outdoor and garden" },
      { value: "pet-supplies", label: "Pet supplies" },
      { value: "restaurants", label: "Restaurants" },
      { value: "services", label: "Services" },
      { value: "sports-and-recreation", label: "Sports and recreation" },
      { value: "toys-and-games", label: "Toys and games" },
      { value: "other", label: "Other" },
    ],
    ESTIMATED_ANNUAL_VOLUME_OPTIONS: [
      { value: "", label: "Select..." },
      { value: "0-100", label: "0-100" },
      { value: "101-500", label: "101-500" },
      { value: "501-1000", label: "501-1000" },
      { value: "1001-5000", label: "1001-5000" },
      { value: "5001-10000", label: "5001-10000" },
      { value: "10001+", label: "10001+" },
      { value: "custom", label: "Custom" },
    ],
  },
};

export const shipvistaConnect = {
  en: {
    HEADER_TITLE: "ShipVista Connect",
    HEADER_SUBTITLE:
      "A dynamic solution that makes shipping cost-effective and effortless.",
    TRACKING_VISIBILITY_TITLE: "Tracking Visibility",
    TRACKING_VISIBILITY_DESC:
      "Get comprehensive tracking details on your shipments. Share them with your customers to ensure transparency and enhance satisfaction.",
    SERVICE_TITLE: "6 Days/Week Service",
    SERVICE_DESC:
      "Maximize your shipping capabilities with extended service availability.",
    SHIPPING_ADVICE_TITLE: "Expert Shipping Advice",
    SHIPPING_ADVICE_DESC:
      "Receive shipping guidance from knowledgeable ShipVista® representatives to streamline your process.",
    FREE_PICKUP_TITLE: "Free Package Pickup",
    FREE_PICKUP_DESC:
      "Save time and energy by scheduling a Free Package Pickup for your shipments — have your packages collected right from your doorstep.",
    PRICING_TITLE: "Competitive Pricing",
    PRICING_DESC:
      "Benefit from a variety of cost-effective shipping solutions tailored to your needs.",
    STATS_TEXT:
      "97% agree that the way companies handle shipping influences whether they will purchase from that company again.",
    CTA_TEXT: "Effortless. Cost-Effective. Exceptional.",
    RETURN_REQUEST_BUTTON: "Get a Shipping Quote",
    CTA_LIST: ["Generate a label", "We pick it up", "Track it all the way"],
    FORM_TITLE: "Get in Touch with Us",
    SHIPMENT_INDUSTRY_OPTIONS: [
      { value: "", label: "Select..." },
      { value: "arts-and-crafts", label: "Arts and crafts" },
      { value: "baby-and-kids", label: "Baby and kids" },
      { value: "books-music-and-video", label: "Books, music, and video" },
      {
        value: "business-equipment-and-supplies",
        label: "Business equipment and supplies",
      },
      { value: "clothing", label: "Clothing" },
      { value: "electronics", label: "Electronics" },
      { value: "food-and-drink", label: "Food and drink" },
      { value: "hardware-and-automotive", label: "Hardware and automotive" },
      { value: "health-and-beauty", label: "Health and beauty" },
      { value: "home-and-decor", label: "Home and decor" },
      { value: "jewelry-and-accessories", label: "Jewelry and accessories" },
      { value: "outdoor-and-garden", label: "Outdoor and garden" },
      { value: "pet-supplies", label: "Pet supplies" },
      { value: "restaurants", label: "Restaurants" },
      { value: "services", label: "Services" },
      { value: "sports-and-recreation", label: "Sports and recreation" },
      { value: "toys-and-games", label: "Toys and games" },
      { value: "other", label: "Other" },
    ],
    ESTIMATED_ANNUAL_VOLUME_OPTIONS: [
      { value: "", label: "Select..." },
      { value: "0-100", label: "0-100" },
      { value: "101-500", label: "101-500" },
      { value: "501-1000", label: "501-1000" },
      { value: "1001-5000", label: "1001-5000" },
      { value: "5001-10000", label: "5001-10000" },
      { value: "10001+", label: "10001+" },
      { value: "custom", label: "Custom" },
    ],
  },
};
